var AccountFieldId = /* @__PURE__ */ ((AccountFieldId2) => {
  AccountFieldId2["ACCOUNT_ID"] = "account_id";
  AccountFieldId2["ACCOUNT_INSERTED_AT"] = "account_insertedAt";
  AccountFieldId2["ACCOUNT_UPDATED_AT"] = "account_updatedAt";
  AccountFieldId2["ACCOUNT_NUMBER"] = "account_number";
  AccountFieldId2["ACCOUNT_NAME"] = "account_name";
  AccountFieldId2["ACCOUNT_KIND"] = "account_kind";
  AccountFieldId2["ACCOUNT_TYPE"] = "account_type";
  AccountFieldId2["ACCOUNT_BALANCE"] = "account_balance";
  AccountFieldId2["ACCOUNT_DEFAULT_VAT_RATE"] = "account_defaultVatRate";
  return AccountFieldId2;
})(AccountFieldId || {});
var kind = /* @__PURE__ */ ((kind2) => {
  kind2["CONDITION"] = "condition";
  return kind2;
})(kind || {});
var AccountKind = /* @__PURE__ */ ((AccountKind2) => {
  AccountKind2["BALANCE_SHEET"] = "balance_sheet";
  AccountKind2["INCOME_STATEMENT"] = "income_statement";
  AccountKind2["FINALIZATION"] = "finalization";
  AccountKind2["CREDITOR"] = "creditor";
  AccountKind2["DEBTOR"] = "debtor";
  AccountKind2["NOT_RELEVANT"] = "not_relevant";
  AccountKind2["UNKNOWN"] = "unknown";
  AccountKind2["SUSPENSE_ACCOUNT"] = "suspense_account";
  return AccountKind2;
})(AccountKind || {});
var AccountObjectType = /* @__PURE__ */ ((AccountObjectType2) => {
  AccountObjectType2["TENANT"] = "tenant";
  AccountObjectType2["ORGANIZATION"] = "organization";
  return AccountObjectType2;
})(AccountObjectType || {});
var AccountType = /* @__PURE__ */ ((AccountType2) => {
  AccountType2["ACTIVE"] = "active";
  AccountType2["PASSIVE"] = "passive";
  AccountType2["INCOME"] = "income";
  AccountType2["EXPENSE"] = "expense";
  AccountType2["CLOSING_BALANCE"] = "closing_balance";
  AccountType2["SUBACCOUNT"] = "subaccount";
  return AccountType2;
})(AccountType || {});
var AccountingBookingsFieldId = /* @__PURE__ */ ((AccountingBookingsFieldId2) => {
  AccountingBookingsFieldId2["ACC_BOOKING_ID"] = "acc_booking_id";
  AccountingBookingsFieldId2["ACC_BOOKING_DEBIT_ACCOUNT_NAME"] = "acc_booking_debitAccountName";
  AccountingBookingsFieldId2["ACC_BOOKING_DEBIT_ACCOUNT_NUMBER"] = "acc_booking_debitAccountNumber";
  AccountingBookingsFieldId2["ACC_BOOKING_CREDIT_ACCOUNT_NAME"] = "acc_booking_creditAccountName";
  AccountingBookingsFieldId2["ACC_BOOKING_CREDIT_ACCOUNT_NUMBER"] = "acc_booking_creditAccountNumber";
  AccountingBookingsFieldId2["ACC_BOOKING_DESCRIPTION"] = "acc_booking_description";
  AccountingBookingsFieldId2["ACC_BOOKING_VAT_AMOUNT"] = "acc_booking_vatAmount";
  AccountingBookingsFieldId2["ACC_BOOKING_VAT_RATE_NAME"] = "acc_booking_vatRateName";
  AccountingBookingsFieldId2["ACC_BOOKING_COST_CENTER"] = "acc_booking_costCenter";
  AccountingBookingsFieldId2["ACC_BOOKING_BOOKING_FILES"] = "acc_booking_bookingFiles";
  return AccountingBookingsFieldId2;
})(AccountingBookingsFieldId || {});
var AccountingErrorType = /* @__PURE__ */ ((AccountingErrorType2) => {
  AccountingErrorType2["INVALID_REPORT_CHART_ID_ERROR"] = "InvalidReportChartIdError";
  AccountingErrorType2["INVALID_REPORT_TEMPLATE_ID_ERROR"] = "InvalidReportTemplateIdError";
  return AccountingErrorType2;
})(AccountingErrorType || {});
var _type = /* @__PURE__ */ ((_type2) => {
  _type2["ORIGIN"] = "origin";
  _type2["CUSTOM"] = "custom";
  return _type2;
})(_type || {});
var AccountsSeedTemplate = /* @__PURE__ */ ((AccountsSeedTemplate2) => {
  AccountsSeedTemplate2["CACH1"] = "CACH1";
  AccountsSeedTemplate2["CAAG1"] = "CAAG1";
  AccountsSeedTemplate2["CAAG2"] = "CAAG2";
  return AccountsSeedTemplate2;
})(AccountsSeedTemplate || {});
var AddressesFieldsFiltersId = /* @__PURE__ */ ((AddressesFieldsFiltersId2) => {
  AddressesFieldsFiltersId2["ADDRESSES_ZIP"] = "addresses.zip";
  AddressesFieldsFiltersId2["ADDRESSES_PLACE"] = "addresses.place";
  AddressesFieldsFiltersId2["ADDRESSES_COUNTRY"] = "addresses.country";
  AddressesFieldsFiltersId2["ADDRESSES_STREET"] = "addresses.street";
  AddressesFieldsFiltersId2["ADDRESSES_HOUSE"] = "addresses.house";
  AddressesFieldsFiltersId2["ADDRESSES_ADDRESS_LINE_1"] = "addresses.address_line_1";
  AddressesFieldsFiltersId2["ADDRESSES_ADDRESS_LINE_2"] = "addresses.address_line_2";
  AddressesFieldsFiltersId2["ADDRESSES_ADDRESS_FULL"] = "addresses.address_full";
  return AddressesFieldsFiltersId2;
})(AddressesFieldsFiltersId || {});
var AvatarType = /* @__PURE__ */ ((AvatarType2) => {
  AvatarType2["INITIALS"] = "initials";
  AvatarType2["SYSTEM"] = "system";
  AvatarType2["SPEC_DOSSIER"] = "spec_dossier";
  return AvatarType2;
})(AvatarType || {});
var BookingFieldId = /* @__PURE__ */ ((BookingFieldId2) => {
  BookingFieldId2["BOOKING_ID"] = "booking_id";
  BookingFieldId2["BOOKING_DEBIT_ACCOUNT_ID"] = "booking_debit_account_id";
  BookingFieldId2["BOOKING_CREDIT_ACCOUNT_ID"] = "booking_credit_account_id";
  BookingFieldId2["BOOKING_AMOUNT"] = "booking_amount";
  BookingFieldId2["BOOKING_DESCRIPTION"] = "booking_description";
  BookingFieldId2["BOOKING_VAT_RATE_ID"] = "booking_vat_rate_id";
  BookingFieldId2["BOOKING_DEBIT_ORGANIZATION_ID"] = "booking_debit_organization_id";
  BookingFieldId2["BOOKING_CREDIT_ORGANIZATION_ID"] = "booking_credit_organization_id";
  BookingFieldId2["BOOKING_DATE"] = "booking_date";
  BookingFieldId2["BOOKING_REFERENCE_RECORD_ID"] = "booking_reference_record_id";
  BookingFieldId2["BOOKING_POSITION"] = "booking_position";
  return BookingFieldId2;
})(BookingFieldId || {});
var BookingRelatedFieldId = /* @__PURE__ */ ((BookingRelatedFieldId2) => {
  BookingRelatedFieldId2["BOOKING_DEBIT_ACCOUNT_NUMBER"] = "booking_debit_account_number";
  BookingRelatedFieldId2["BOOKING_DEBIT_ACCOUNT_NAME"] = "booking_debit_account_name";
  BookingRelatedFieldId2["BOOKING_DEBIT_ORGANIZATION_NAME"] = "booking_debit_organization_name";
  BookingRelatedFieldId2["BOOKING_CREDIT_ACCOUNT_NUMBER"] = "booking_credit_account_number";
  BookingRelatedFieldId2["BOOKING_CREDIT_ACCOUNT_NAME"] = "booking_credit_account_name";
  BookingRelatedFieldId2["BOOKING_CREDIT_ORGANIZATION_NAME"] = "booking_credit_organization_name";
  BookingRelatedFieldId2["BOOKING_RECORD_REFERENCED_PROJECT_NAME"] = "booking_record_referenced_project_name";
  BookingRelatedFieldId2["BOOKING_RECORD_REFERENCED_CONTACT_NAME"] = "booking_record_referenced_contact_name";
  BookingRelatedFieldId2["BOOKING_RECORD_REFERENCED_ANLAGE_NAME"] = "booking_record_referenced_anlage_name";
  BookingRelatedFieldId2["BOOKING_RECORD_COST_CENTER_NAME"] = "booking_record_cost_center_name";
  BookingRelatedFieldId2["BOOKING_RECORD_VAT_RATE_NAME"] = "booking_record_vat_rate_name";
  BookingRelatedFieldId2["BOOKING_RECORD_LINKED_FILE_NAME"] = "booking_record_linked_file_name";
  return BookingRelatedFieldId2;
})(BookingRelatedFieldId || {});
var BuiltinModuleTag = /* @__PURE__ */ ((BuiltinModuleTag2) => {
  BuiltinModuleTag2["DOCUMENTS"] = "documents";
  BuiltinModuleTag2["PROJECTS"] = "projects";
  BuiltinModuleTag2["CONTACTS"] = "contacts";
  BuiltinModuleTag2["EMAILS"] = "emails";
  BuiltinModuleTag2["FILES"] = "files";
  BuiltinModuleTag2["ACCOUNTING"] = "accounting";
  BuiltinModuleTag2["SETTINGS_ACCOUNTING"] = "settings_accounting";
  BuiltinModuleTag2["ASSETS"] = "assets";
  BuiltinModuleTag2["PRODUCTS"] = "products";
  return BuiltinModuleTag2;
})(BuiltinModuleTag || {});
var CategoryFieldId = /* @__PURE__ */ ((CategoryFieldId2) => {
  CategoryFieldId2["CATEGORY_ID"] = "category_id";
  CategoryFieldId2["CATEGORY_NAME"] = "category_name";
  CategoryFieldId2["CATEGORY_INSERTED_AT"] = "category_insertedAt";
  CategoryFieldId2["CATEGORY_UPDATED_AT"] = "category_updatedAt";
  return CategoryFieldId2;
})(CategoryFieldId || {});
var CategoryKind = /* @__PURE__ */ ((CategoryKind2) => {
  CategoryKind2["PUBLIC"] = "public";
  CategoryKind2["PRIVATE"] = "private";
  return CategoryKind2;
})(CategoryKind || {});
var statusCode = /* @__PURE__ */ ((statusCode2) => {
  statusCode2[statusCode2["_404"] = 404] = "_404";
  return statusCode2;
})(statusCode || {});
var errorCode = /* @__PURE__ */ ((errorCode2) => {
  errorCode2["CATEGORY_NOT_FOUND_ERROR"] = "CategoryNotFoundError";
  return errorCode2;
})(errorCode || {});
var ComparisonOperator = /* @__PURE__ */ ((ComparisonOperator2) => {
  ComparisonOperator2["EQ"] = "EQ";
  ComparisonOperator2["NEQ"] = "NEQ";
  ComparisonOperator2["LT"] = "LT";
  ComparisonOperator2["LTE"] = "LTE";
  ComparisonOperator2["GT"] = "GT";
  ComparisonOperator2["GTE"] = "GTE";
  ComparisonOperator2["CONTAINS"] = "CONTAINS";
  ComparisonOperator2["NOT_CONTAINS"] = "NOT_CONTAINS";
  return ComparisonOperator2;
})(ComparisonOperator || {});
var ContactAddressCategory = /* @__PURE__ */ ((ContactAddressCategory2) => {
  ContactAddressCategory2["PRIVATE"] = "private";
  ContactAddressCategory2["BUSINESS"] = "business";
  ContactAddressCategory2["VACATION"] = "vacation";
  ContactAddressCategory2["OTHER"] = "other";
  return ContactAddressCategory2;
})(ContactAddressCategory || {});
var ContactAddressFieldId = /* @__PURE__ */ ((ContactAddressFieldId2) => {
  ContactAddressFieldId2["CONTACT_ADDRESS_CATEGORY"] = "contactAddress_category";
  ContactAddressFieldId2["CONTACT_ADDRESS_STREET"] = "contactAddress_street";
  ContactAddressFieldId2["CONTACT_ADDRESS_HOUSE"] = "contactAddress_house";
  ContactAddressFieldId2["CONTACT_ADDRESS_ZIP"] = "contactAddress_zip";
  ContactAddressFieldId2["CONTACT_ADDRESS_PLACE"] = "contactAddress_place";
  ContactAddressFieldId2["CONTACT_ADDRESS_COUNTRY"] = "contactAddress_country";
  ContactAddressFieldId2["CONTACT_ADDRESS_INSERTED_AT"] = "contactAddress_insertedAt";
  ContactAddressFieldId2["CONTACT_ADDRESS_UPDATED_AT"] = "contactAddress_updatedAt";
  ContactAddressFieldId2["CONTACT_ADDRESS_ADDRESS_LINE1"] = "contactAddress_addressLine1";
  ContactAddressFieldId2["CONTACT_ADDRESS_ADDRESS_LINE2"] = "contactAddress_addressLine2";
  return ContactAddressFieldId2;
})(ContactAddressFieldId || {});
var ContactRecordFieldId = /* @__PURE__ */ ((ContactRecordFieldId2) => {
  ContactRecordFieldId2["CONTACT_RECORD_SALUTATION"] = "contactRecord_salutation";
  ContactRecordFieldId2["CONTACT_RECORD_CUSTOM_SALUTATION"] = "contactRecord_customSalutation";
  ContactRecordFieldId2["CONTACT_RECORD_TITLE"] = "contactRecord_title";
  ContactRecordFieldId2["CONTACT_RECORD_FIRST_NAME"] = "contactRecord_firstName";
  ContactRecordFieldId2["CONTACT_RECORD_LAST_NAME"] = "contactRecord_lastName";
  ContactRecordFieldId2["CONTACT_RECORD_MIDDLE_NAMES"] = "contactRecord_middleNames";
  ContactRecordFieldId2["CONTACT_RECORD_NICKNAMES"] = "contactRecord_nicknames";
  ContactRecordFieldId2["CONTACT_RECORD_ORGANIZATION_NAME"] = "contactRecord_organizationName";
  ContactRecordFieldId2["CONTACT_RECORD_DATE_OF_BIRTH"] = "contactRecord_dateOfBirth";
  ContactRecordFieldId2["CONTACT_RECORD_USER_ID"] = "contactRecord_userId";
  return ContactRecordFieldId2;
})(ContactRecordFieldId || {});
var CopyStatus = /* @__PURE__ */ ((CopyStatus2) => {
  CopyStatus2["DONE"] = "Done";
  CopyStatus2["IN_PROGRESS"] = "InProgress";
  CopyStatus2["ERROR"] = "Error";
  CopyStatus2["TERMINATED"] = "Terminated";
  return CopyStatus2;
})(CopyStatus || {});
var CustomSequenceErrorType = /* @__PURE__ */ ((CustomSequenceErrorType2) => {
  CustomSequenceErrorType2["CUSTOM_SEQUENCE_NOT_FOUND_ERROR"] = "CustomSequenceNotFoundError";
  CustomSequenceErrorType2["CUSTOM_SEQUENCE_INVALID_ID_ERROR"] = "CustomSequenceInvalidIdError";
  CustomSequenceErrorType2["CUSTOM_SEQUENCE_INVALID_INPUT_ERROR"] = "CustomSequenceInvalidInputError";
  CustomSequenceErrorType2["CUSTOM_SEQUENCE_RESERVED_PREFIX_ERROR"] = "CustomSequenceReservedPrefixError";
  return CustomSequenceErrorType2;
})(CustomSequenceErrorType || {});
var DateFormatsDash = /* @__PURE__ */ ((DateFormatsDash2) => {
  DateFormatsDash2["DD_MM_YYYY"] = "dd-MM-yyyy";
  DateFormatsDash2["MM_DD_YYYY"] = "MM-dd-yyyy";
  DateFormatsDash2["YYYY_MM_DD"] = "yyyy-MM-dd";
  DateFormatsDash2["DD_MM_YY"] = "dd-MM-yy";
  DateFormatsDash2["D_M_YY"] = "d-M-yy";
  return DateFormatsDash2;
})(DateFormatsDash || {});
var DateFormatsDot = /* @__PURE__ */ ((DateFormatsDot2) => {
  DateFormatsDot2["DD_MM_YYYY"] = "dd.MM.yyyy";
  DateFormatsDot2["MM_DD_YYYY"] = "MM.dd.yyyy";
  DateFormatsDot2["YYYY_MM_DD"] = "yyyy.MM.dd";
  DateFormatsDot2["DD_MM_YY"] = "dd.MM.yy";
  DateFormatsDot2["D_M_YY"] = "d.M.yy";
  return DateFormatsDot2;
})(DateFormatsDot || {});
var DateFormatsSlash = /* @__PURE__ */ ((DateFormatsSlash2) => {
  DateFormatsSlash2["DD_MM_YYYY"] = "dd/MM/yyyy";
  DateFormatsSlash2["MM_DD_YYYY"] = "MM/dd/yyyy";
  DateFormatsSlash2["YYYY_MM_DD"] = "yyyy/MM/dd";
  DateFormatsSlash2["DD_MM_YY"] = "dd/MM/yy";
  DateFormatsSlash2["D_M_YY"] = "d/M/yy";
  DateFormatsSlash2["MMMM_DD_YYYY"] = "MMMM/dd/yyyy";
  return DateFormatsSlash2;
})(DateFormatsSlash || {});
var DateFormatsText = /* @__PURE__ */ ((DateFormatsText2) => {
  DateFormatsText2["D_MMMM_YYYY"] = "d. MMMM yyyy";
  return DateFormatsText2;
})(DateFormatsText || {});
var DatePrecision = /* @__PURE__ */ ((DatePrecision2) => {
  DatePrecision2["YY"] = "yy";
  DatePrecision2["MM"] = "mm";
  DatePrecision2["YY_MM"] = "yy_mm";
  DatePrecision2["YY_MM_DD"] = "yy_mm_dd";
  return DatePrecision2;
})(DatePrecision || {});
var DecimalSeparator = /* @__PURE__ */ ((DecimalSeparator2) => {
  DecimalSeparator2["COMMA"] = "comma";
  DecimalSeparator2["POINT"] = "point";
  return DecimalSeparator2;
})(DecimalSeparator || {});
var ErrorResource = /* @__PURE__ */ ((ErrorResource2) => {
  ErrorResource2["ACCOUNTING_BOOKING"] = "AccountingBooking";
  ErrorResource2["ORGANIZATION"] = "Organization";
  ErrorResource2["UNSPECIFIED"] = "Unspecified";
  ErrorResource2["SETTING_PERMISSION"] = "SettingPermission";
  ErrorResource2["MODULE_PERMISSION"] = "ModulePermission";
  ErrorResource2["TEMPLATE_PERMISSION"] = "TemplatePermission";
  ErrorResource2["ROLE"] = "Role";
  ErrorResource2["USER_ROLE"] = "UserRole";
  ErrorResource2["USERGROUP_ROLE"] = "UsergroupRole";
  ErrorResource2["RECORD"] = "Record";
  ErrorResource2["TEMPLATE"] = "Template";
  ErrorResource2["FIELD"] = "Field";
  ErrorResource2["FIELD_PROXY"] = "FieldProxy";
  return ErrorResource2;
})(ErrorResource || {});
var FieldBlockType = /* @__PURE__ */ ((FieldBlockType2) => {
  FieldBlockType2["FIELDS"] = "fields";
  FieldBlockType2["NOTES"] = "notes";
  FieldBlockType2["BOOKINGS"] = "bookings";
  FieldBlockType2["FOLDERS"] = "folders";
  FieldBlockType2["PRODUCT_PRICE"] = "product_price";
  return FieldBlockType2;
})(FieldBlockType || {});
var FieldContentType = /* @__PURE__ */ ((FieldContentType2) => {
  FieldContentType2["TEXT"] = "text";
  FieldContentType2["TEXT_ARRAY"] = "textArray";
  FieldContentType2["TYPED_TEXT"] = "typedText";
  FieldContentType2["TEXT_AREA"] = "textArea";
  FieldContentType2["NUMBER"] = "number";
  FieldContentType2["DATE"] = "date";
  FieldContentType2["DATETIME"] = "datetime";
  FieldContentType2["CALCULATION"] = "calculation";
  FieldContentType2["RECORD_REFERENCES"] = "recordReferences";
  FieldContentType2["TAG_REFERENCES"] = "tagReferences";
  FieldContentType2["CATEGORY_REFERENCES"] = "categoryReferences";
  FieldContentType2["ORGANIZATION_REFERENCES"] = "organizationReferences";
  FieldContentType2["STATUS_REFERENCE"] = "statusReference";
  FieldContentType2["PRIORITY_REFERENCE"] = "priorityReference";
  FieldContentType2["URL"] = "url";
  FieldContentType2["CHECKBOX"] = "checkbox";
  FieldContentType2["LIST"] = "list";
  FieldContentType2["RADIO"] = "radio";
  FieldContentType2["FILE"] = "file";
  FieldContentType2["FILE_LIST"] = "fileList";
  FieldContentType2["MONEY"] = "money";
  FieldContentType2["CURRENCY"] = "currency";
  FieldContentType2["CHILD_TREE"] = "childTree";
  FieldContentType2["SPECIAL"] = "special";
  FieldContentType2["GROUP"] = "group";
  FieldContentType2["GROUP_LIST"] = "groupList";
  FieldContentType2["USER_REFERENCES"] = "userReferences";
  FieldContentType2["HTML_TEXT"] = "htmlText";
  FieldContentType2["EMAIL_CONTACT_REFERENCES"] = "emailContactReferences";
  FieldContentType2["TENANT_REFERENCE"] = "tenantReference";
  FieldContentType2["ACCOUNT_REPORT_TEMPLATE_REFERENCE"] = "accountReportTemplateReference";
  FieldContentType2["TEMPLATE_KIND_REFERENCE"] = "templateKindReference";
  FieldContentType2["MULTI_CHECKBOX"] = "multiCheckbox";
  FieldContentType2["BIRTHDAY"] = "birthday";
  FieldContentType2["TIME"] = "time";
  FieldContentType2["ADDRESS_LIST"] = "addressList";
  FieldContentType2["RECIPIENTS_LIST"] = "recipientsList";
  FieldContentType2["EMAIL"] = "email";
  FieldContentType2["PHONE"] = "phone";
  return FieldContentType2;
})(FieldContentType || {});
var FieldGroupId = /* @__PURE__ */ ((FieldGroupId2) => {
  FieldGroupId2["ID"] = "id";
  FieldGroupId2["INSERTED_AT"] = "insertedAt";
  FieldGroupId2["UPDATED_AT"] = "updatedAt";
  FieldGroupId2["LABEL"] = "label";
  FieldGroupId2["DESCRIPTION"] = "description";
  FieldGroupId2["FIELD_TYPE"] = "fieldType";
  return FieldGroupId2;
})(FieldGroupId || {});
var FieldId = /* @__PURE__ */ ((FieldId2) => {
  FieldId2["ID"] = "id";
  FieldId2["INSERTED_AT"] = "insertedAt";
  FieldId2["UPDATED_AT"] = "updatedAt";
  FieldId2["CONTENT_TYPE"] = "contentType";
  FieldId2["LABEL"] = "label";
  FieldId2["FIELD_TYPE"] = "fieldType";
  FieldId2["FIELD_KIND"] = "fieldKind";
  return FieldId2;
})(FieldId || {});
var FieldKind = /* @__PURE__ */ ((FieldKind2) => {
  FieldKind2["TEXT_FIELD"] = "text_field";
  FieldKind2["SINGLE_SELECTION"] = "single_selection";
  FieldKind2["MULTIPLE_SELECTION"] = "multiple_selection";
  FieldKind2["NUMBER_VALUE"] = "number_value";
  FieldKind2["DATE_TIME"] = "date_time";
  FieldKind2["REFERENCES"] = "references";
  FieldKind2["SPECIAL_FIELDS"] = "special_fields";
  FieldKind2["CUSTOM_TABLE"] = "custom_table";
  return FieldKind2;
})(FieldKind || {});
var FieldNumberType = /* @__PURE__ */ ((FieldNumberType2) => {
  FieldNumberType2["INTEGER"] = "integer";
  FieldNumberType2["DECIMAL"] = "decimal";
  FieldNumberType2["PERCENTAGE"] = "percentage";
  return FieldNumberType2;
})(FieldNumberType || {});
var FieldType = /* @__PURE__ */ ((FieldType2) => {
  FieldType2["CUSTOM_FIELD"] = "custom_field";
  FieldType2["SYSTEM_FIELD"] = "system_field";
  FieldType2["INNER_TEMPLATE_FIELD"] = "inner_template_field";
  FieldType2["CUSTOM_NESTED_FIELD"] = "custom_nested_field";
  return FieldType2;
})(FieldType || {});
var FieldValidatorKind = /* @__PURE__ */ ((FieldValidatorKind2) => {
  FieldValidatorKind2["REQUIRED"] = "required";
  FieldValidatorKind2["MIN_LENGTH"] = "minLength";
  FieldValidatorKind2["MAX_LENGTH"] = "maxLength";
  FieldValidatorKind2["MIN_VALUE"] = "minValue";
  FieldValidatorKind2["MAX_VALUE"] = "maxValue";
  FieldValidatorKind2["BETWEEN"] = "between";
  return FieldValidatorKind2;
})(FieldValidatorKind || {});
var FileExplorerNodeKind = /* @__PURE__ */ ((FileExplorerNodeKind2) => {
  FileExplorerNodeKind2["FILE"] = "file";
  FileExplorerNodeKind2["FOLDER"] = "folder";
  return FileExplorerNodeKind2;
})(FileExplorerNodeKind || {});
var FileFolderFieldId = /* @__PURE__ */ ((FileFolderFieldId2) => {
  FileFolderFieldId2["FILE_FOLDER_ID"] = "fileFolder_id";
  FileFolderFieldId2["FILE_FOLDER_NAME"] = "fileFolder_name";
  FileFolderFieldId2["FILE_FOLDER_INSERTED_AT"] = "fileFolder_insertedAt";
  FileFolderFieldId2["FILE_FOLDER_INSERTED_BY"] = "fileFolder_insertedBy";
  FileFolderFieldId2["FILE_FOLDER_UPDATED_AT"] = "fileFolder_updatedAt";
  FileFolderFieldId2["FILE_FOLDER_UPDATED_BY"] = "fileFolder_updatedBy";
  return FileFolderFieldId2;
})(FileFolderFieldId || {});
var FileFolderType = /* @__PURE__ */ ((FileFolderType2) => {
  FileFolderType2["DEFAULT"] = "default";
  FileFolderType2["TEMPLATES"] = "templates";
  FileFolderType2["CUSTOM"] = "custom";
  return FileFolderType2;
})(FileFolderType || {});
var FileRecordFieldId = /* @__PURE__ */ ((FileRecordFieldId2) => {
  FileRecordFieldId2["FILE_RECORD_FOLDER_ID"] = "fileRecord_folderId";
  FileRecordFieldId2["FILE_SIZE"] = "file_size";
  FileRecordFieldId2["FILE_TYPE"] = "file_type";
  return FileRecordFieldId2;
})(FileRecordFieldId || {});
var FileVersionFieldId = /* @__PURE__ */ ((FileVersionFieldId2) => {
  FileVersionFieldId2["VERSION"] = "version";
  FileVersionFieldId2["GENERATION"] = "generation";
  FileVersionFieldId2["SIZE"] = "size";
  FileVersionFieldId2["CREATED_BY"] = "createdBy";
  FileVersionFieldId2["CREATED_AT"] = "createdAt";
  FileVersionFieldId2["NOTE"] = "note";
  return FileVersionFieldId2;
})(FileVersionFieldId || {});
var FileimportProviderType = /* @__PURE__ */ ((FileimportProviderType2) => {
  FileimportProviderType2["GDRIVE"] = "gdrive";
  return FileimportProviderType2;
})(FileimportProviderType || {});
var FileimportResourceRecordType = /* @__PURE__ */ ((FileimportResourceRecordType2) => {
  FileimportResourceRecordType2["PUBLIC"] = "public";
  FileimportResourceRecordType2["PRIVATE"] = "private";
  return FileimportResourceRecordType2;
})(FileimportResourceRecordType || {});
var FilterPermissionType = /* @__PURE__ */ ((FilterPermissionType2) => {
  FilterPermissionType2["PUBLIC"] = "public";
  FilterPermissionType2["PRIVATE"] = "private";
  FilterPermissionType2["INDIVIDUAL"] = "individual";
  return FilterPermissionType2;
})(FilterPermissionType || {});
var FilterScope = /* @__PURE__ */ ((FilterScope2) => {
  FilterScope2["MODULE"] = "module";
  FilterScope2["RELATION"] = "relation";
  FilterScope2["FILE_EXPLORER"] = "file_explorer";
  FilterScope2["BOOKINGS"] = "bookings";
  FilterScope2["PRODUCT_PRICE_SALE"] = "product_price_sale";
  FilterScope2["PRODUCT_PRICE_PURCHASE"] = "product_price_purchase";
  FilterScope2["PRODUCT_PRICE_RENT"] = "product_price_rent";
  FilterScope2["PRODUCT_PRICE_RENTOUT"] = "product_price_rentout";
  return FilterScope2;
})(FilterScope || {});
var FiltersetIndividualPermissionFieldId = /* @__PURE__ */ ((FiltersetIndividualPermissionFieldId2) => {
  FiltersetIndividualPermissionFieldId2["FILTERSET_INDIVIDUAL_PERMISSION_ID"] = "filtersetIndividualPermission_id";
  FiltersetIndividualPermissionFieldId2["FILTERSET_INDIVIDUAL_PERMISSION_INSERTED_AT"] = "filtersetIndividualPermission_insertedAt";
  FiltersetIndividualPermissionFieldId2["FILTERSET_INDIVIDUAL_PERMISSION_INSERTED_BY"] = "filtersetIndividualPermission_insertedBy";
  FiltersetIndividualPermissionFieldId2["FILTERSET_INDIVIDUAL_PERMISSION_UPDATED_AT"] = "filtersetIndividualPermission_updatedAt";
  FiltersetIndividualPermissionFieldId2["FILTERSET_INDIVIDUAL_PERMISSION_UPDATED_BY"] = "filtersetIndividualPermission_updatedBy";
  FiltersetIndividualPermissionFieldId2["FILTERSET_INDIVIDUAL_PERMISSION_FILTERSET_ID"] = "filtersetIndividualPermission_filtersetId";
  FiltersetIndividualPermissionFieldId2["FILTERSET_INDIVIDUAL_PERMISSION_FILTERSET_NAME"] = "filtersetIndividualPermission_filtersetName";
  FiltersetIndividualPermissionFieldId2["FILTERSET_INDIVIDUAL_PERMISSION_USER_ID"] = "filtersetIndividualPermission_userId";
  return FiltersetIndividualPermissionFieldId2;
})(FiltersetIndividualPermissionFieldId || {});
var HtmlTextEditorVariant = /* @__PURE__ */ ((HtmlTextEditorVariant2) => {
  HtmlTextEditorVariant2["FULL_TOOLBAR"] = "full_toolbar";
  HtmlTextEditorVariant2["COMPACT_TOOLBAR"] = "compact_toolbar";
  return HtmlTextEditorVariant2;
})(HtmlTextEditorVariant || {});
var ImplicitRecordRelationFieldId = /* @__PURE__ */ ((ImplicitRecordRelationFieldId2) => {
  ImplicitRecordRelationFieldId2["IMPLICIT_RECORD_RELATION_INHERITED_BY"] = "implicitRecordRelation_inheritedBy";
  ImplicitRecordRelationFieldId2["FROM_ID"] = "from_id";
  ImplicitRecordRelationFieldId2["FROM"] = "from";
  ImplicitRecordRelationFieldId2["TO_ID"] = "to_id";
  ImplicitRecordRelationFieldId2["TO"] = "to";
  ImplicitRecordRelationFieldId2["RECIPIENTS_TO"] = "recipients.to";
  ImplicitRecordRelationFieldId2["CC"] = "cc";
  ImplicitRecordRelationFieldId2["RECIPIENTS_CC"] = "recipients.cc";
  ImplicitRecordRelationFieldId2["BCC"] = "bcc";
  ImplicitRecordRelationFieldId2["RECIPIENTS_BCC"] = "recipients.bcc";
  ImplicitRecordRelationFieldId2["FYI_CONTACTS"] = "fyi_contacts";
  ImplicitRecordRelationFieldId2["RECIPIENTS_FYI_CONTACTS"] = "recipients.fyi_contacts";
  ImplicitRecordRelationFieldId2["RESPONSIBLE"] = "responsible";
  ImplicitRecordRelationFieldId2["RESPONSIBLE_ID"] = "responsible_id";
  ImplicitRecordRelationFieldId2["INVOLVED"] = "involved";
  ImplicitRecordRelationFieldId2["INVOLVED_ID"] = "involved_id";
  ImplicitRecordRelationFieldId2["RELATED_PROJECT"] = "related_project";
  ImplicitRecordRelationFieldId2["RELATED_PROJECT_ID"] = "related_project_id";
  ImplicitRecordRelationFieldId2["RELATED_ANLAGE"] = "related_anlage";
  ImplicitRecordRelationFieldId2["RELATED_ANLAGE_ID"] = "related_anlage_id";
  ImplicitRecordRelationFieldId2["IMPLICIT_RELATIONS_TO_ID"] = "implicit_relations.to_id";
  return ImplicitRecordRelationFieldId2;
})(ImplicitRecordRelationFieldId || {});
var LayoutAlignVertical = /* @__PURE__ */ ((LayoutAlignVertical2) => {
  LayoutAlignVertical2["TOP"] = "top";
  LayoutAlignVertical2["CENTER"] = "center";
  return LayoutAlignVertical2;
})(LayoutAlignVertical || {});
var LayoutRowType = /* @__PURE__ */ ((LayoutRowType2) => {
  LayoutRowType2["BASIC"] = "basic";
  LayoutRowType2["GROUP"] = "group";
  LayoutRowType2["HEADLINE"] = "headline";
  return LayoutRowType2;
})(LayoutRowType || {});
var LayoutSectionGroupErrorType = /* @__PURE__ */ ((LayoutSectionGroupErrorType2) => {
  LayoutSectionGroupErrorType2["LAYOUT_SECTION_GROUP_NOT_FOUND_ERROR"] = "LayoutSectionGroupNotFoundError";
  LayoutSectionGroupErrorType2["LAYOUT_SECTION_GROUP_INVALID_ID_ERROR"] = "LayoutSectionGroupInvalidIdError";
  LayoutSectionGroupErrorType2["LAYOUT_SECTION_GROUP_INVALID_INPUT_ERROR"] = "LayoutSectionGroupInvalidInputError";
  LayoutSectionGroupErrorType2["STATUS_TRANSITION_NOT_ALLOWED_ERROR"] = "StatusTransitionNotAllowedError";
  LayoutSectionGroupErrorType2["LAYOUT_SECTION_GROUP_NOT_APPROVED_ERROR"] = "LayoutSectionGroupNotApprovedError";
  return LayoutSectionGroupErrorType2;
})(LayoutSectionGroupErrorType || {});
var LayoutSectionGroupKind = /* @__PURE__ */ ((LayoutSectionGroupKind2) => {
  LayoutSectionGroupKind2["SIDEBAR"] = "sidebar";
  LayoutSectionGroupKind2["SALE"] = "sale";
  LayoutSectionGroupKind2["PURCHASE"] = "purchase";
  LayoutSectionGroupKind2["RENT"] = "rent";
  LayoutSectionGroupKind2["RENTOUT"] = "rentout";
  return LayoutSectionGroupKind2;
})(LayoutSectionGroupKind || {});
var LayoutSectionStatus = /* @__PURE__ */ ((LayoutSectionStatus2) => {
  LayoutSectionStatus2["ACTIVE"] = "active";
  LayoutSectionStatus2["HIDDEN"] = "hidden";
  return LayoutSectionStatus2;
})(LayoutSectionStatus || {});
var LayoutSectionType = /* @__PURE__ */ ((LayoutSectionType2) => {
  LayoutSectionType2["HEAD"] = "head";
  LayoutSectionType2["BODY"] = "body";
  LayoutSectionType2["NOTES"] = "notes";
  LayoutSectionType2["BOOKINGS"] = "bookings";
  LayoutSectionType2["FILES"] = "files";
  LayoutSectionType2["SIDE_BAR"] = "side_bar";
  LayoutSectionType2["RELATIONS"] = "relations";
  LayoutSectionType2["PRODUCT_PRICE_SALE"] = "product_price_sale";
  LayoutSectionType2["PRODUCT_PRICE_PURCHASE"] = "product_price_purchase";
  LayoutSectionType2["PRODUCT_PRICE_RENT"] = "product_price_rent";
  LayoutSectionType2["PRODUCT_PRICE_RENTOUT"] = "product_price_rentout";
  return LayoutSectionType2;
})(LayoutSectionType || {});
var LogicalOperator = /* @__PURE__ */ ((LogicalOperator2) => {
  LogicalOperator2["AND"] = "AND";
  LogicalOperator2["OR"] = "OR";
  return LogicalOperator2;
})(LogicalOperator || {});
var MailboxAccountResourceRecordType = /* @__PURE__ */ ((MailboxAccountResourceRecordType2) => {
  MailboxAccountResourceRecordType2["PUBLIC"] = "public";
  MailboxAccountResourceRecordType2["PRIVATE"] = "private";
  return MailboxAccountResourceRecordType2;
})(MailboxAccountResourceRecordType || {});
var MailboxAccountResourceType = /* @__PURE__ */ ((MailboxAccountResourceType2) => {
  MailboxAccountResourceType2["EMAIL"] = "email";
  MailboxAccountResourceType2["EVENT"] = "event";
  return MailboxAccountResourceType2;
})(MailboxAccountResourceType || {});
var MailboxProviderType = /* @__PURE__ */ ((MailboxProviderType2) => {
  MailboxProviderType2["GRAPH"] = "graph";
  MailboxProviderType2["IMAP_SMTP"] = "imapSmtp";
  MailboxProviderType2["GMAIL"] = "gmail";
  return MailboxProviderType2;
})(MailboxProviderType || {});
var lifecycleEvent = /* @__PURE__ */ ((lifecycleEvent2) => {
  lifecycleEvent2["REAUTHORIZATION_REQUIRED"] = "reauthorizationRequired";
  lifecycleEvent2["SUBSCRIPTION_REMOVED"] = "subscriptionRemoved";
  lifecycleEvent2["MISSED"] = "missed";
  return lifecycleEvent2;
})(lifecycleEvent || {});
var changeType = /* @__PURE__ */ ((changeType2) => {
  changeType2["CREATED"] = "created";
  changeType2["UPDATED"] = "updated";
  changeType2["DELETED"] = "deleted";
  return changeType2;
})(changeType || {});
var NotesType = /* @__PURE__ */ ((NotesType2) => {
  NotesType2["PUBLIC"] = "public";
  NotesType2["PRIVATE"] = "private";
  NotesType2["CUSTOM"] = "custom";
  NotesType2["CUSTOM_PUBLIC"] = "custom_public";
  NotesType2["CUSTOM_PRIVATE"] = "custom_private";
  return NotesType2;
})(NotesType || {});
var docType = /* @__PURE__ */ ((docType2) => {
  docType2["WORD"] = "word";
  docType2["CELL"] = "cell";
  docType2["SLIDE"] = "slide";
  return docType2;
})(docType || {});
var accountObjectType = /* @__PURE__ */ ((accountObjectType2) => {
  accountObjectType2["ORGANIZATION"] = "organization";
  return accountObjectType2;
})(accountObjectType || {});
var PriorityFieldId = /* @__PURE__ */ ((PriorityFieldId2) => {
  PriorityFieldId2["PRIORITY"] = "priority";
  return PriorityFieldId2;
})(PriorityFieldId || {});
var PrivateCategoryFieldId = /* @__PURE__ */ ((PrivateCategoryFieldId2) => {
  PrivateCategoryFieldId2["PRIVATE_CATEGORY_NAME"] = "privateCategory_name";
  return PrivateCategoryFieldId2;
})(PrivateCategoryFieldId || {});
var ProductPriceFieldId = /* @__PURE__ */ ((ProductPriceFieldId2) => {
  ProductPriceFieldId2["PRODUCT_PRICE_ID"] = "product_price_id";
  ProductPriceFieldId2["PRODUCT_PRICE_RECORD_ID"] = "product_price_record_id";
  ProductPriceFieldId2["PRODUCT_PRICE_PRICE_TYPE"] = "product_price_price_type";
  ProductPriceFieldId2["PRODUCT_PRICE_NET_PRICE"] = "product_price_net_price";
  ProductPriceFieldId2["PRODUCT_PRICE_VAT_RATE"] = "product_price_vat_rate";
  ProductPriceFieldId2["PRODUCT_PRICE_ADDITIONAL_COSTS_INCL_VAT"] = "product_price_additional_costs_incl_vat";
  ProductPriceFieldId2["PRODUCT_PRICE_VAT_AMOUNT"] = "product_price_vat_amount";
  ProductPriceFieldId2["PRODUCT_PRICE_GROSS_PRICE"] = "product_price_gross_price";
  ProductPriceFieldId2["PRODUCT_PRICE_ADDITIONAL_COSTS"] = "product_price_additional_costs";
  ProductPriceFieldId2["PRODUCT_PRICE_GROSS_PRICE_INCL_COSTS"] = "product_price_gross_price_incl_costs";
  ProductPriceFieldId2["PRODUCT_PRICE_CURRENCY"] = "product_price_currency";
  ProductPriceFieldId2["PRODUCT_PRICE_EXCHANGE_RATE"] = "product_price_exchange_rate";
  ProductPriceFieldId2["PRODUCT_PRICE_TERMINATION_REASONS"] = "product_price_termination_reasons";
  ProductPriceFieldId2["PRODUCT_PRICE_START_DATE"] = "product_price_start_date";
  ProductPriceFieldId2["PRODUCT_PRICE_NOTE"] = "product_price_note";
  ProductPriceFieldId2["PRODUCT_PRICE_PRIVATE_NOTE"] = "product_price_private_note";
  ProductPriceFieldId2["PRODUCT_PRICE_PRICE_INDEX"] = "product_price_price_index";
  ProductPriceFieldId2["PRODUCT_PRICE_INTEREST_RATE"] = "product_price_interest_rate";
  ProductPriceFieldId2["PRODUCT_PRICE_ASSET_RECORD_ID"] = "product_price_asset_record_id";
  ProductPriceFieldId2["PRODUCT_PRICE_PROJECT_RECORD_ID"] = "product_price_project_record_id";
  ProductPriceFieldId2["PRODUCT_PRICE_LISTING_START_DATE"] = "product_price_listing_start_date";
  ProductPriceFieldId2["PRODUCT_PRICE_VACANT_FROM"] = "product_price_vacant_from";
  ProductPriceFieldId2["PRODUCT_PRICE_RENTAL_NOTE"] = "product_price_rental_note";
  ProductPriceFieldId2["PRODUCT_PRICE_PRIVATE_RENTAL_NOTE"] = "product_price_private_rental_note";
  return ProductPriceFieldId2;
})(ProductPriceFieldId || {});
var ProductPriceRelatedFieldId = /* @__PURE__ */ ((ProductPriceRelatedFieldId2) => {
  ProductPriceRelatedFieldId2["PRODUCT_PRICE_RECORD_ASSET_NAME"] = "product_price_record_asset_name";
  ProductPriceRelatedFieldId2["PRODUCT_PRICE_RECORD_PROJECT_NAME"] = "product_price_record_project_name";
  ProductPriceRelatedFieldId2["PRODUCT_PRICE_RECORD_LINK_NAME"] = "product_price_record_link_name";
  ProductPriceRelatedFieldId2["PRODUCT_PRICE_STATUS_ID"] = "product_price_status_id";
  return ProductPriceRelatedFieldId2;
})(ProductPriceRelatedFieldId || {});
var ProductPriceType = /* @__PURE__ */ ((ProductPriceType2) => {
  ProductPriceType2["SALES"] = "sales";
  ProductPriceType2["RENT_OUT"] = "rent-out";
  ProductPriceType2["PURCHASE"] = "purchase";
  ProductPriceType2["RENT"] = "rent";
  return ProductPriceType2;
})(ProductPriceType || {});
var ProjectFieldId = /* @__PURE__ */ ((ProjectFieldId2) => {
  ProjectFieldId2["FILE_RECORD_PARENT_NAME"] = "fileRecord_parentName";
  return ProjectFieldId2;
})(ProjectFieldId || {});
var PublicCategoryFieldId = /* @__PURE__ */ ((PublicCategoryFieldId2) => {
  PublicCategoryFieldId2["PUBLIC_CATEGORY_NAME"] = "publicCategory_name";
  return PublicCategoryFieldId2;
})(PublicCategoryFieldId || {});
var RangeUnbound = /* @__PURE__ */ ((RangeUnbound2) => {
  RangeUnbound2["UNBOUND"] = "unbound";
  return RangeUnbound2;
})(RangeUnbound || {});
var RecordAccessRightType = /* @__PURE__ */ ((RecordAccessRightType2) => {
  RecordAccessRightType2["ADMIN"] = "Admin";
  RecordAccessRightType2["GROUP"] = "Group";
  RecordAccessRightType2["ROLE"] = "Role";
  return RecordAccessRightType2;
})(RecordAccessRightType || {});
var RecordAccessRightsFieldId = /* @__PURE__ */ ((RecordAccessRightsFieldId2) => {
  RecordAccessRightsFieldId2["USER_ID"] = "user_id";
  RecordAccessRightsFieldId2["USER_NAME"] = "user_name";
  RecordAccessRightsFieldId2["USER_EMAIL"] = "user_email";
  RecordAccessRightsFieldId2["PERMISSION"] = "permission";
  RecordAccessRightsFieldId2["INSERTED_AT"] = "inserted_at";
  RecordAccessRightsFieldId2["INSERTED_BY"] = "inserted_by";
  RecordAccessRightsFieldId2["INSERTED_BY_NAME"] = "inserted_by_name";
  RecordAccessRightsFieldId2["INSERTED_BY_EMAIL"] = "inserted_by_email";
  RecordAccessRightsFieldId2["ACCESS_TYPE"] = "access_type";
  return RecordAccessRightsFieldId2;
})(RecordAccessRightsFieldId || {});
var RecordAction = /* @__PURE__ */ ((RecordAction2) => {
  RecordAction2["EMAIL_FORWARD"] = "email-forward";
  RecordAction2["EMAIL_REPLY"] = "email-reply";
  RecordAction2["EMAIL_REPLY_ALL"] = "email-reply-all";
  RecordAction2["EMAIL_SEND"] = "email-send";
  return RecordAction2;
})(RecordAction || {});
var RecordActionCreateFromMode = /* @__PURE__ */ ((RecordActionCreateFromMode2) => {
  RecordActionCreateFromMode2["SINGLE"] = "single";
  RecordActionCreateFromMode2["MULTIPLE"] = "multiple";
  return RecordActionCreateFromMode2;
})(RecordActionCreateFromMode || {});
var RecordEventAction = /* @__PURE__ */ ((RecordEventAction2) => {
  RecordEventAction2["CREATED"] = "created";
  RecordEventAction2["UPDATED"] = "updated";
  RecordEventAction2["DELETED"] = "deleted";
  return RecordEventAction2;
})(RecordEventAction || {});
var RecordEventFieldId = /* @__PURE__ */ ((RecordEventFieldId2) => {
  RecordEventFieldId2["INSERTED_AT"] = "insertedAt";
  RecordEventFieldId2["ACTION"] = "action";
  RecordEventFieldId2["TARGET"] = "target";
  RecordEventFieldId2["ACTOR"] = "actor";
  RecordEventFieldId2["FIELD"] = "field";
  RecordEventFieldId2["OLD"] = "old";
  RecordEventFieldId2["NEW"] = "new";
  return RecordEventFieldId2;
})(RecordEventFieldId || {});
var RecordEventTarget = /* @__PURE__ */ ((RecordEventTarget2) => {
  RecordEventTarget2["RECORD"] = "record";
  RecordEventTarget2["FIELD"] = "field";
  return RecordEventTarget2;
})(RecordEventTarget || {});
var RecordExplicitRelationFieldId = /* @__PURE__ */ ((RecordExplicitRelationFieldId2) => {
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_ID"] = "recordExplicitRelation_id";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_TO_ID"] = "recordExplicitRelation_toId";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_FROM_ID"] = "recordExplicitRelation_fromId";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_INSERTED_AT"] = "recordExplicitRelation_insertedAt";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_INSERTED_BY"] = "recordExplicitRelation_insertedBy";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_UPDATED_AT"] = "recordExplicitRelation_updatedAt";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_UPDATED_BY"] = "recordExplicitRelation_updatedBy";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_NOTES"] = "recordExplicitRelation_notes";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_ROLE"] = "recordExplicitRelation_role";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_RECORD_NAME"] = "recordExplicitRelation_recordName";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_VALID_FROM"] = "recordExplicitRelation_validFrom";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_VALID_TO"] = "recordExplicitRelation_validTo";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_FAVORITE"] = "recordExplicitRelation_favorite";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_TEMPLATE_ID"] = "recordExplicitRelation_templateId";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_TEMPLATE_ID_FROM"] = "recordExplicitRelation_templateIdFrom";
  RecordExplicitRelationFieldId2["RECORD_EXPLICIT_RELATION_TEMPLATE_ID_TO"] = "recordExplicitRelation_templateIdTo";
  return RecordExplicitRelationFieldId2;
})(RecordExplicitRelationFieldId || {});
var RecordFieldId = /* @__PURE__ */ ((RecordFieldId2) => {
  RecordFieldId2["RECORD_ID"] = "record_id";
  RecordFieldId2["RECORD_INSERTED_AT"] = "record_insertedAt";
  RecordFieldId2["RECORD_INSERTED_BY"] = "record_insertedBy";
  RecordFieldId2["RECORD_UPDATED_AT"] = "record_updatedAt";
  RecordFieldId2["RECORD_UPDATED_BY"] = "record_updatedBy";
  RecordFieldId2["RECORD_NAME"] = "record_name";
  RecordFieldId2["RECORD_TEMPLATE_ID"] = "record_templateId";
  RecordFieldId2["RECORD_SCAYLA_ID"] = "record_scaylaId";
  RecordFieldId2["RECORD_DEADLINE"] = "record_deadline";
  RecordFieldId2["RECORD_STATE"] = "record_state";
  return RecordFieldId2;
})(RecordFieldId || {});
var RecordIndividualPermissionFieldId = /* @__PURE__ */ ((RecordIndividualPermissionFieldId2) => {
  RecordIndividualPermissionFieldId2["RECORD_INDIVIDUAL_PERMISSION_ID"] = "recordIndividualPermission_id";
  RecordIndividualPermissionFieldId2["RECORD_INDIVIDUAL_PERMISSION_INSERTED_AT"] = "recordIndividualPermission_insertedAt";
  RecordIndividualPermissionFieldId2["RECORD_INDIVIDUAL_PERMISSION_INSERTED_BY"] = "recordIndividualPermission_insertedBy";
  RecordIndividualPermissionFieldId2["RECORD_INDIVIDUAL_PERMISSION_UPDATED_AT"] = "recordIndividualPermission_updatedAt";
  RecordIndividualPermissionFieldId2["RECORD_INDIVIDUAL_PERMISSION_UPDATED_BY"] = "recordIndividualPermission_updatedBy";
  RecordIndividualPermissionFieldId2["RECORD_INDIVIDUAL_PERMISSION_RECORD_ID"] = "recordIndividualPermission_recordId";
  RecordIndividualPermissionFieldId2["RECORD_INDIVIDUAL_PERMISSION_RECORD_NAME"] = "recordIndividualPermission_recordName";
  RecordIndividualPermissionFieldId2["RECORD_INDIVIDUAL_PERMISSION_USER_ID"] = "recordIndividualPermission_userId";
  return RecordIndividualPermissionFieldId2;
})(RecordIndividualPermissionFieldId || {});
var RecordPermissionType = /* @__PURE__ */ ((RecordPermissionType2) => {
  RecordPermissionType2["PUBLIC"] = "Public";
  RecordPermissionType2["PRIVATE"] = "Private";
  RecordPermissionType2["INDIVIDUAL"] = "Individual";
  return RecordPermissionType2;
})(RecordPermissionType || {});
var RecordPriorityBucket = /* @__PURE__ */ ((RecordPriorityBucket2) => {
  RecordPriorityBucket2["LOW"] = "low";
  RecordPriorityBucket2["NORMAL"] = "normal";
  RecordPriorityBucket2["HIGH"] = "high";
  return RecordPriorityBucket2;
})(RecordPriorityBucket || {});
var RecordPrioritySetStatus = /* @__PURE__ */ ((RecordPrioritySetStatus2) => {
  RecordPrioritySetStatus2["APPROVED"] = "approved";
  RecordPrioritySetStatus2["LOCKED"] = "locked";
  return RecordPrioritySetStatus2;
})(RecordPrioritySetStatus || {});
var RecordStatusBucket = /* @__PURE__ */ ((RecordStatusBucket2) => {
  RecordStatusBucket2["PROCESSING"] = "processing";
  RecordStatusBucket2["OPEN"] = "open";
  RecordStatusBucket2["IN_PROGRESS"] = "in_progress";
  RecordStatusBucket2["CLOSED"] = "closed";
  return RecordStatusBucket2;
})(RecordStatusBucket || {});
var RecordStatusSetErrorType = /* @__PURE__ */ ((RecordStatusSetErrorType2) => {
  RecordStatusSetErrorType2["RECORD_STATUS_SET_NOT_APPROVED_ERROR"] = "RecordStatusSetNotApprovedError";
  return RecordStatusSetErrorType2;
})(RecordStatusSetErrorType || {});
var RecordStatusSetStatus = /* @__PURE__ */ ((RecordStatusSetStatus2) => {
  RecordStatusSetStatus2["APPROVED"] = "approved";
  RecordStatusSetStatus2["LOCKED"] = "locked";
  return RecordStatusSetStatus2;
})(RecordStatusSetStatus || {});
var RecordStatusSlug = /* @__PURE__ */ ((RecordStatusSlug2) => {
  RecordStatusSlug2["DRAFT"] = "draft";
  RecordStatusSlug2["AI_PROCESSING"] = "ai_processing";
  RecordStatusSlug2["AI_DRAFT"] = "ai_draft";
  RecordStatusSlug2["AI_ERROR"] = "ai_error";
  RecordStatusSlug2["AI_DUPLICATE"] = "ai_duplicate";
  return RecordStatusSlug2;
})(RecordStatusSlug || {});
var RecordTemplatesFolderId = /* @__PURE__ */ ((RecordTemplatesFolderId2) => {
  RecordTemplatesFolderId2["TEMPLATES_FOLDER_ID"] = "templates_folderId";
  return RecordTemplatesFolderId2;
})(RecordTemplatesFolderId || {});
var RecordVersionEvent = /* @__PURE__ */ ((RecordVersionEvent2) => {
  RecordVersionEvent2["CREATE"] = "create";
  RecordVersionEvent2["UPDATE"] = "update";
  RecordVersionEvent2["DELETE"] = "delete";
  return RecordVersionEvent2;
})(RecordVersionEvent || {});
var ReferencesDisplayVariant = /* @__PURE__ */ ((ReferencesDisplayVariant2) => {
  ReferencesDisplayVariant2["LIST"] = "list";
  ReferencesDisplayVariant2["TAGS"] = "tags";
  return ReferencesDisplayVariant2;
})(ReferencesDisplayVariant || {});
var RelatedRecordFieldId = /* @__PURE__ */ ((RelatedRecordFieldId2) => {
  RelatedRecordFieldId2["RELATED_RECORD"] = "related_record";
  RelatedRecordFieldId2["RELATED_RECORD_MODULE"] = "related_record_module";
  return RelatedRecordFieldId2;
})(RelatedRecordFieldId || {});
var ResponsibleUserFieldId = /* @__PURE__ */ ((ResponsibleUserFieldId2) => {
  ResponsibleUserFieldId2["RESPONSIBLE_USER_NAME"] = "responsibleUser_name";
  ResponsibleUserFieldId2["RESPONSIBLE_USER_EMAIL"] = "responsibleUser_email";
  return ResponsibleUserFieldId2;
})(ResponsibleUserFieldId || {});
var RoleErrorType = /* @__PURE__ */ ((RoleErrorType2) => {
  RoleErrorType2["ROLE_NAME_DUPLICATE_ERROR"] = "RoleNameDuplicateError";
  return RoleErrorType2;
})(RoleErrorType || {});
var RootFileFolderFieldId = /* @__PURE__ */ ((RootFileFolderFieldId2) => {
  RootFileFolderFieldId2["ROOT_FILE_FOLDER_TOTAL_FILE_COUNT"] = "rootFileFolder_totalFileCount";
  return RootFileFolderFieldId2;
})(RootFileFolderFieldId || {});
var Salutation = /* @__PURE__ */ ((Salutation2) => {
  Salutation2["MR"] = "mr";
  Salutation2["MRS"] = "mrs";
  Salutation2["OTHER"] = "other";
  return Salutation2;
})(Salutation || {});
var Services = /* @__PURE__ */ ((Services2) => {
  Services2["MAILBOX_GRAPH"] = "mailbox_graph";
  Services2["MAILBOX_GMAIL"] = "mailbox_gmail";
  Services2["FILEIMPORT_GDRIVE"] = "fileimport_gdrive";
  Services2["MAILBOX_IMAP_SMTP"] = "mailbox_imap_smtp";
  return Services2;
})(Services || {});
var SettingKind = /* @__PURE__ */ ((SettingKind2) => {
  SettingKind2["NONE"] = "none";
  SettingKind2["USER"] = "user";
  SettingKind2["MODULE"] = "module";
  SettingKind2["SYSTEM"] = "system";
  return SettingKind2;
})(SettingKind || {});
var SettingName = /* @__PURE__ */ ((SettingName2) => {
  SettingName2["NAVBAR_TYPE"] = "navbar_type";
  SettingName2["NAVBAR_VIEW"] = "navbar_view";
  SettingName2["RECORD_EDIT_MODE"] = "record_edit_mode";
  SettingName2["UNDERLINE_VARIANT_VISIBILITY"] = "underline_variant_visibility";
  SettingName2["COUNTRY_CODE"] = "country_code";
  SettingName2["HOME_TIMEZONE"] = "home_timezone";
  SettingName2["DATE_FORMAT"] = "date_format";
  SettingName2["TIME_FORMAT"] = "time_format";
  SettingName2["ACCENT_COLOR"] = "accent_color";
  SettingName2["DECIMAL_PLACES_NUMBER"] = "decimal_places_number";
  SettingName2["FAVORITES"] = "favorites";
  SettingName2["IMPLICIT_RELATIONS_TAB_VIEW"] = "implicit_relations_tab_view";
  SettingName2["LANGUAGE"] = "language";
  SettingName2["DEFAULT_TENANT"] = "default_tenant";
  SettingName2["DECIMAL_SEPARATOR"] = "decimal_separator";
  SettingName2["THOUSANDS_SEPARATOR"] = "thousands_separator";
  SettingName2["DATE_FIELD_MONTHS_COUNT"] = "date_field_months_count";
  SettingName2["DATE_FIELD_MONTH_COLUMNS"] = "date_field_month_columns";
  SettingName2["HEADER_VIEW_MODE"] = "header_view_mode";
  SettingName2["TABLE_COLUMN_LAYOUT"] = "table_column_layout";
  SettingName2["TABLE_COLUMNS_ORDER"] = "table_columns_order";
  SettingName2["TABLE_COLUMNS_SIZE"] = "table_columns_size";
  SettingName2["TABLE_COLUMNS_VISIBILITY"] = "table_columns_visibility";
  SettingName2["TABLE_COLUMNS_TOTAL"] = "table_columns_total";
  SettingName2["TABLE_TOTAL_ROW_STATE"] = "table_total_row_state";
  SettingName2["TEMPLATE_SECTION_EXPAND_TYPE"] = "template_section_expand_type";
  SettingName2["LAYOUT_ROW_FIELD_GROUP_EXPAND_TYPE"] = "layout_row_field_group_expand_type";
  SettingName2["LANGUAGES"] = "languages";
  return SettingName2;
})(SettingName || {});
var SettingType = /* @__PURE__ */ ((SettingType2) => {
  SettingType2["STRING"] = "string";
  SettingType2["INTEGER"] = "integer";
  SettingType2["BOOLEAN"] = "boolean";
  SettingType2["JSON"] = "json";
  return SettingType2;
})(SettingType || {});
var SidebarStatus = /* @__PURE__ */ ((SidebarStatus2) => {
  SidebarStatus2["DRAFT"] = "draft";
  SidebarStatus2["APPROVED"] = "approved";
  SidebarStatus2["LOCKED"] = "locked";
  return SidebarStatus2;
})(SidebarStatus || {});
var SingleSelectionDisplayVariant = /* @__PURE__ */ ((SingleSelectionDisplayVariant2) => {
  SingleSelectionDisplayVariant2["CHECKBOX"] = "checkbox";
  SingleSelectionDisplayVariant2["TOGGLE"] = "toggle";
  return SingleSelectionDisplayVariant2;
})(SingleSelectionDisplayVariant || {});
var SpecialDataKind = /* @__PURE__ */ ((SpecialDataKind2) => {
  SpecialDataKind2["CONTACT"] = "contact";
  SpecialDataKind2["INVOICE"] = "invoice";
  SpecialDataKind2["FILE"] = "file";
  SpecialDataKind2["PROJECT"] = "project";
  SpecialDataKind2["EMAIL"] = "email";
  SpecialDataKind2["ASSET"] = "asset";
  SpecialDataKind2["ACCOUNTING_SETTING_ACCOUNT"] = "accountingSettingAccount";
  SpecialDataKind2["ACCOUNTING_SETTING_REPORTING_STRUCTURE"] = "accountingSettingReportingStructure";
  SpecialDataKind2["PRODUCT"] = "product";
  return SpecialDataKind2;
})(SpecialDataKind || {});
var StatusFieldId = /* @__PURE__ */ ((StatusFieldId2) => {
  StatusFieldId2["STATUS"] = "status";
  return StatusFieldId2;
})(StatusFieldId || {});
var SystemTemplateSlug = /* @__PURE__ */ ((SystemTemplateSlug2) => {
  SystemTemplateSlug2["SYSTEM_TEMPLATE_SLUG_FILE"] = "systemTemplateSlug_file";
  SystemTemplateSlug2["SYSTEM_TEMPLATE_SLUG_CONTACT_PERSON"] = "systemTemplateSlug_contactPerson";
  SystemTemplateSlug2["SYSTEM_TEMPLATE_SLUG_CONTACT_COMPANY"] = "systemTemplateSlug_contactCompany";
  SystemTemplateSlug2["SYSTEM_TEMPLATE_SLUG_EMAIL_INBOX"] = "systemTemplateSlug_emailInbox";
  SystemTemplateSlug2["SYSTEM_TEMPLATE_SLUG_EMAIL_DRAFT"] = "systemTemplateSlug_emailDraft";
  SystemTemplateSlug2["SYSTEM_TEMPLATE_SLUG_EMAIL_SENT"] = "systemTemplateSlug_emailSent";
  SystemTemplateSlug2["SYSTEM_TEMPLATE_SLUG_ACCOUNTING_ACCOUNT"] = "systemTemplateSlug_accountingAccount";
  SystemTemplateSlug2["SYSTEM_TEMPLATE_SLUG_ACCOUNTING_ACCOUNTS_STRUCTURE"] = "systemTemplateSlug_accountingAccountsStructure";
  SystemTemplateSlug2["SYSTEM_TEMPLATE_SLUG_ACCOUNTING_COST_CENTER"] = "systemTemplateSlug_accountingCostCenter";
  return SystemTemplateSlug2;
})(SystemTemplateSlug || {});
var TableBarViewType = /* @__PURE__ */ ((TableBarViewType2) => {
  TableBarViewType2["LIST"] = "list";
  TableBarViewType2["DOSSIER"] = "dossier";
  TableBarViewType2["GALLERY"] = "gallery";
  return TableBarViewType2;
})(TableBarViewType || {});
var TableColumnKind = /* @__PURE__ */ ((TableColumnKind2) => {
  TableColumnKind2["TEXT"] = "text";
  TableColumnKind2["TEXT_ARRAY"] = "textArray";
  TableColumnKind2["TYPED_TEXT"] = "typedText";
  TableColumnKind2["TEXT_AREA"] = "textArea";
  TableColumnKind2["NUMBER"] = "number";
  TableColumnKind2["DATE"] = "date";
  TableColumnKind2["DATETIME"] = "datetime";
  TableColumnKind2["CALCULATION"] = "calculation";
  TableColumnKind2["RECORD_REFERENCES"] = "recordReferences";
  TableColumnKind2["TAG_REFERENCES"] = "tagReferences";
  TableColumnKind2["CATEGORY_REFERENCES"] = "categoryReferences";
  TableColumnKind2["ORGANIZATION_REFERENCES"] = "organizationReferences";
  TableColumnKind2["STATUS_REFERENCE"] = "statusReference";
  TableColumnKind2["PRIORITY_REFERENCE"] = "priorityReference";
  TableColumnKind2["URL"] = "url";
  TableColumnKind2["CHECKBOX"] = "checkbox";
  TableColumnKind2["LIST"] = "list";
  TableColumnKind2["RADIO"] = "radio";
  TableColumnKind2["FILE"] = "file";
  TableColumnKind2["FILE_LIST"] = "fileList";
  TableColumnKind2["MONEY"] = "money";
  TableColumnKind2["CURRENCY"] = "currency";
  TableColumnKind2["CHILD_TREE"] = "childTree";
  TableColumnKind2["SPECIAL"] = "special";
  TableColumnKind2["GROUP"] = "group";
  TableColumnKind2["GROUP_LIST"] = "groupList";
  TableColumnKind2["USER_REFERENCES"] = "userReferences";
  TableColumnKind2["HTML_TEXT"] = "htmlText";
  TableColumnKind2["EMAIL_CONTACT_REFERENCES"] = "emailContactReferences";
  TableColumnKind2["TENANT_REFERENCE"] = "tenantReference";
  TableColumnKind2["ACCOUNT_REPORT_TEMPLATE_REFERENCE"] = "accountReportTemplateReference";
  TableColumnKind2["TEMPLATE_KIND_REFERENCE"] = "templateKindReference";
  TableColumnKind2["MULTI_CHECKBOX"] = "multiCheckbox";
  TableColumnKind2["BIRTHDAY"] = "birthday";
  TableColumnKind2["TIME"] = "time";
  TableColumnKind2["ADDRESS_LIST"] = "addressList";
  TableColumnKind2["RECIPIENTS_LIST"] = "recipientsList";
  TableColumnKind2["EMAIL"] = "email";
  TableColumnKind2["PHONE"] = "phone";
  TableColumnKind2["AVATAR"] = "avatar";
  TableColumnKind2["ATTACHMENT_AMOUNT"] = "attachment_amount";
  return TableColumnKind2;
})(TableColumnKind || {});
var TagFieldId = /* @__PURE__ */ ((TagFieldId2) => {
  TagFieldId2["TAG_ID"] = "tag_id";
  TagFieldId2["TAG_NAME"] = "tag_name";
  TagFieldId2["TAG_MODULE_ID"] = "tag_moduleId";
  TagFieldId2["TAG_ORGANIZATION_ID"] = "tag_organizationId";
  TagFieldId2["TAG_INSERTED_AT"] = "tag_insertedAt";
  TagFieldId2["TAG_UPDATED_AT"] = "tag_updatedAt";
  return TagFieldId2;
})(TagFieldId || {});
var TemplateFeatureType = /* @__PURE__ */ ((TemplateFeatureType2) => {
  TemplateFeatureType2["NAME"] = "name";
  TemplateFeatureType2["TOOLTIP"] = "tooltip";
  TemplateFeatureType2["VISIBLE_ACCOUNTING_COLUMN"] = "visible_accounting_column";
  return TemplateFeatureType2;
})(TemplateFeatureType || {});
var TemplateFieldId = /* @__PURE__ */ ((TemplateFieldId2) => {
  TemplateFieldId2["TEMPLATE_ID"] = "template_id";
  TemplateFieldId2["TEMPLATE_INSERTED_AT"] = "template_insertedAt";
  TemplateFieldId2["TEMPLATE_UPDATED_AT"] = "template_updatedAt";
  TemplateFieldId2["TEMPLATE_MODULE_ID"] = "template_moduleId";
  TemplateFieldId2["TEMPLATE_ORGANIZATION_ID"] = "template_organizationId";
  TemplateFieldId2["TEMPLATE_NAME"] = "template_name";
  TemplateFieldId2["TEMPLATE_NAME_TRANSLATIONS"] = "template_nameTranslations";
  TemplateFieldId2["TEMPLATE_SHOW_IN_NAVIGATION"] = "template_showInNavigation";
  TemplateFieldId2["TEMPLATE_SYSTEM_TEMPLATE_SLUG"] = "template_systemTemplateSlug";
  TemplateFieldId2["TEMPLATE_FILE_COUNT"] = "template_fileCount";
  TemplateFieldId2["TEMPLATE_STATUS"] = "template_status";
  return TemplateFieldId2;
})(TemplateFieldId || {});
var TenantConfigErrorType = /* @__PURE__ */ ((TenantConfigErrorType2) => {
  TenantConfigErrorType2["TENANT_CONFIG_PARENT_ID_ERROR"] = "TenantConfigParentIdError";
  TenantConfigErrorType2["TENANT_CONFIG_NOT_FOUND_ERROR"] = "TenantConfigNotFoundError";
  TenantConfigErrorType2["TENANT_CONFIG_CHECK_ERROR"] = "TenantConfigCheckError";
  return TenantConfigErrorType2;
})(TenantConfigErrorType || {});
var TenantConfigState = /* @__PURE__ */ ((TenantConfigState2) => {
  TenantConfigState2["NONE"] = "none";
  TenantConfigState2["ACTIVE"] = "active";
  TenantConfigState2["ERROR"] = "error";
  return TenantConfigState2;
})(TenantConfigState || {});
var TenantConfigStatus = /* @__PURE__ */ ((TenantConfigStatus2) => {
  TenantConfigStatus2["ACTIVE"] = "active";
  TenantConfigStatus2["INACTIVE"] = "inactive";
  return TenantConfigStatus2;
})(TenantConfigStatus || {});
var TenantConfigType = /* @__PURE__ */ ((TenantConfigType2) => {
  TenantConfigType2["MAILBOX_PROVIDER"] = "mailbox_provider";
  TenantConfigType2["MAILBOX_ACCOUNT"] = "mailbox_account";
  TenantConfigType2["MAILBOX_RESOURCE"] = "mailbox_resource";
  TenantConfigType2["FILEIMPORT_PROVIDER"] = "fileimport_provider";
  TenantConfigType2["FILEIMPORT_RESOURCE"] = "fileimport_resource";
  return TenantConfigType2;
})(TenantConfigType || {});
var TenantType = /* @__PURE__ */ ((TenantType2) => {
  TenantType2["ERP"] = "erp";
  TenantType2["DRIVE"] = "drive";
  TenantType2["MANDATOR_MANAGEMENT"] = "mandator_management";
  return TenantType2;
})(TenantType || {});
var ThousandsSeparator = /* @__PURE__ */ ((ThousandsSeparator2) => {
  ThousandsSeparator2["COMMA"] = "comma";
  ThousandsSeparator2["POINT"] = "point";
  ThousandsSeparator2["APOSTROPHE"] = "apostrophe";
  ThousandsSeparator2["NONE"] = "none";
  ThousandsSeparator2["SPACE"] = "space";
  return ThousandsSeparator2;
})(ThousandsSeparator || {});
var TimeFormats = /* @__PURE__ */ ((TimeFormats2) => {
  TimeFormats2["HH:MM"] = "HH:mm";
  TimeFormats2["H:M"] = "H:m";
  TimeFormats2["HH:MM_AA"] = "hh:mm aa";
  TimeFormats2["H:M_AA"] = "h:m aa";
  TimeFormats2["HH:MM:SS_SSS"] = "HH:mm:ss.SSS";
  TimeFormats2["H:M:S_SSS"] = "H:m:s.SSS";
  TimeFormats2["HH:MM:SS_SSS_AA"] = "hh:mm:ss.SSS aa";
  TimeFormats2["H:M:S_SSS_AA"] = "h:m:s.SSS aa";
  return TimeFormats2;
})(TimeFormats || {});
var TimePrecision = /* @__PURE__ */ ((TimePrecision2) => {
  TimePrecision2["HH"] = "hh";
  TimePrecision2["HH_MM"] = "hh_mm";
  TimePrecision2["HH_MM_SS"] = "hh_mm_ss";
  TimePrecision2["HH_MM_SS_MS"] = "hh_mm_ss_ms";
  return TimePrecision2;
})(TimePrecision || {});
var TimeZones = /* @__PURE__ */ ((TimeZones2) => {
  TimeZones2["AFRICA_ABIDJAN"] = "Africa/Abidjan";
  TimeZones2["AFRICA_ACCRA"] = "Africa/Accra";
  TimeZones2["AFRICA_ADDIS_ABABA"] = "Africa/Addis_Ababa";
  TimeZones2["AFRICA_ALGIERS"] = "Africa/Algiers";
  TimeZones2["AFRICA_ASMARA"] = "Africa/Asmara";
  TimeZones2["AFRICA_ASMERA"] = "Africa/Asmera";
  TimeZones2["AFRICA_BAMAKO"] = "Africa/Bamako";
  TimeZones2["AFRICA_BANGUI"] = "Africa/Bangui";
  TimeZones2["AFRICA_BANJUL"] = "Africa/Banjul";
  TimeZones2["AFRICA_BISSAU"] = "Africa/Bissau";
  TimeZones2["AFRICA_BLANTYRE"] = "Africa/Blantyre";
  TimeZones2["AFRICA_BRAZZAVILLE"] = "Africa/Brazzaville";
  TimeZones2["AFRICA_BUJUMBURA"] = "Africa/Bujumbura";
  TimeZones2["AFRICA_CAIRO"] = "Africa/Cairo";
  TimeZones2["AFRICA_CASABLANCA"] = "Africa/Casablanca";
  TimeZones2["AFRICA_CEUTA"] = "Africa/Ceuta";
  TimeZones2["AFRICA_CONAKRY"] = "Africa/Conakry";
  TimeZones2["AFRICA_DAKAR"] = "Africa/Dakar";
  TimeZones2["AFRICA_DAR_ES_SALAAM"] = "Africa/Dar_es_Salaam";
  TimeZones2["AFRICA_DJIBOUTI"] = "Africa/Djibouti";
  TimeZones2["AFRICA_DOUALA"] = "Africa/Douala";
  TimeZones2["AFRICA_EL_AAIUN"] = "Africa/El_Aaiun";
  TimeZones2["AFRICA_FREETOWN"] = "Africa/Freetown";
  TimeZones2["AFRICA_GABORONE"] = "Africa/Gaborone";
  TimeZones2["AFRICA_HARARE"] = "Africa/Harare";
  TimeZones2["AFRICA_JOHANNESBURG"] = "Africa/Johannesburg";
  TimeZones2["AFRICA_JUBA"] = "Africa/Juba";
  TimeZones2["AFRICA_KAMPALA"] = "Africa/Kampala";
  TimeZones2["AFRICA_KHARTOUM"] = "Africa/Khartoum";
  TimeZones2["AFRICA_KIGALI"] = "Africa/Kigali";
  TimeZones2["AFRICA_KINSHASA"] = "Africa/Kinshasa";
  TimeZones2["AFRICA_LAGOS"] = "Africa/Lagos";
  TimeZones2["AFRICA_LIBREVILLE"] = "Africa/Libreville";
  TimeZones2["AFRICA_LOME"] = "Africa/Lome";
  TimeZones2["AFRICA_LUANDA"] = "Africa/Luanda";
  TimeZones2["AFRICA_LUBUMBASHI"] = "Africa/Lubumbashi";
  TimeZones2["AFRICA_LUSAKA"] = "Africa/Lusaka";
  TimeZones2["AFRICA_MALABO"] = "Africa/Malabo";
  TimeZones2["AFRICA_MAPUTO"] = "Africa/Maputo";
  TimeZones2["AFRICA_MASERU"] = "Africa/Maseru";
  TimeZones2["AFRICA_MBABANE"] = "Africa/Mbabane";
  TimeZones2["AFRICA_MOGADISHU"] = "Africa/Mogadishu";
  TimeZones2["AFRICA_MONROVIA"] = "Africa/Monrovia";
  TimeZones2["AFRICA_NAIROBI"] = "Africa/Nairobi";
  TimeZones2["AFRICA_NDJAMENA"] = "Africa/Ndjamena";
  TimeZones2["AFRICA_NIAMEY"] = "Africa/Niamey";
  TimeZones2["AFRICA_NOUAKCHOTT"] = "Africa/Nouakchott";
  TimeZones2["AFRICA_OUAGADOUGOU"] = "Africa/Ouagadougou";
  TimeZones2["AFRICA_PORTO_NOVO"] = "Africa/Porto-Novo";
  TimeZones2["AFRICA_SAO_TOME"] = "Africa/Sao_Tome";
  TimeZones2["AFRICA_TIMBUKTU"] = "Africa/Timbuktu";
  TimeZones2["AFRICA_TRIPOLI"] = "Africa/Tripoli";
  TimeZones2["AFRICA_TUNIS"] = "Africa/Tunis";
  TimeZones2["AFRICA_WINDHOEK"] = "Africa/Windhoek";
  TimeZones2["AMERICA_ADAK"] = "America/Adak";
  TimeZones2["AMERICA_ANCHORAGE"] = "America/Anchorage";
  TimeZones2["AMERICA_ANGUILLA"] = "America/Anguilla";
  TimeZones2["AMERICA_ANTIGUA"] = "America/Antigua";
  TimeZones2["AMERICA_ARAGUAINA"] = "America/Araguaina";
  TimeZones2["AMERICA_ARGENTINA_BUENOS_AIRES"] = "America/Argentina/Buenos_Aires";
  TimeZones2["AMERICA_ARGENTINA_CATAMARCA"] = "America/Argentina/Catamarca";
  TimeZones2["AMERICA_ARGENTINA_COMOD_RIVADAVIA"] = "America/Argentina/ComodRivadavia";
  TimeZones2["AMERICA_ARGENTINA_CORDOBA"] = "America/Argentina/Cordoba";
  TimeZones2["AMERICA_ARGENTINA_JUJUY"] = "America/Argentina/Jujuy";
  TimeZones2["AMERICA_ARGENTINA_LA_RIOJA"] = "America/Argentina/La_Rioja";
  TimeZones2["AMERICA_ARGENTINA_MENDOZA"] = "America/Argentina/Mendoza";
  TimeZones2["AMERICA_ARGENTINA_RIO_GALLEGOS"] = "America/Argentina/Rio_Gallegos";
  TimeZones2["AMERICA_ARGENTINA_SALTA"] = "America/Argentina/Salta";
  TimeZones2["AMERICA_ARGENTINA_SAN_JUAN"] = "America/Argentina/San_Juan";
  TimeZones2["AMERICA_ARGENTINA_SAN_LUIS"] = "America/Argentina/San_Luis";
  TimeZones2["AMERICA_ARGENTINA_TUCUMAN"] = "America/Argentina/Tucuman";
  TimeZones2["AMERICA_ARGENTINA_USHUAIA"] = "America/Argentina/Ushuaia";
  TimeZones2["AMERICA_ARUBA"] = "America/Aruba";
  TimeZones2["AMERICA_ASUNCION"] = "America/Asuncion";
  TimeZones2["AMERICA_ATIKOKAN"] = "America/Atikokan";
  TimeZones2["AMERICA_ATKA"] = "America/Atka";
  TimeZones2["AMERICA_BAHIA"] = "America/Bahia";
  TimeZones2["AMERICA_BAHIA_BANDERAS"] = "America/Bahia_Banderas";
  TimeZones2["AMERICA_BARBADOS"] = "America/Barbados";
  TimeZones2["AMERICA_BELEM"] = "America/Belem";
  TimeZones2["AMERICA_BELIZE"] = "America/Belize";
  TimeZones2["AMERICA_BLANC_SABLON"] = "America/Blanc-Sablon";
  TimeZones2["AMERICA_BOA_VISTA"] = "America/Boa_Vista";
  TimeZones2["AMERICA_BOGOTA"] = "America/Bogota";
  TimeZones2["AMERICA_BOISE"] = "America/Boise";
  TimeZones2["AMERICA_BUENOS_AIRES"] = "America/Buenos_Aires";
  TimeZones2["AMERICA_CAMBRIDGE_BAY"] = "America/Cambridge_Bay";
  TimeZones2["AMERICA_CAMPO_GRANDE"] = "America/Campo_Grande";
  TimeZones2["AMERICA_CANCUN"] = "America/Cancun";
  TimeZones2["AMERICA_CARACAS"] = "America/Caracas";
  TimeZones2["AMERICA_CATAMARCA"] = "America/Catamarca";
  TimeZones2["AMERICA_CAYENNE"] = "America/Cayenne";
  TimeZones2["AMERICA_CAYMAN"] = "America/Cayman";
  TimeZones2["AMERICA_CHICAGO"] = "America/Chicago";
  TimeZones2["AMERICA_CHIHUAHUA"] = "America/Chihuahua";
  TimeZones2["AMERICA_CIUDAD_JUAREZ"] = "America/Ciudad_Juarez";
  TimeZones2["AMERICA_CORAL_HARBOUR"] = "America/Coral_Harbour";
  TimeZones2["AMERICA_CORDOBA"] = "America/Cordoba";
  TimeZones2["AMERICA_COSTA_RICA"] = "America/Costa_Rica";
  TimeZones2["AMERICA_CRESTON"] = "America/Creston";
  TimeZones2["AMERICA_CUIABA"] = "America/Cuiaba";
  TimeZones2["AMERICA_CURACAO"] = "America/Curacao";
  TimeZones2["AMERICA_DANMARKSHAVN"] = "America/Danmarkshavn";
  TimeZones2["AMERICA_DAWSON"] = "America/Dawson";
  TimeZones2["AMERICA_DAWSON_CREEK"] = "America/Dawson_Creek";
  TimeZones2["AMERICA_DENVER"] = "America/Denver";
  TimeZones2["AMERICA_DETROIT"] = "America/Detroit";
  TimeZones2["AMERICA_DOMINICA"] = "America/Dominica";
  TimeZones2["AMERICA_EDMONTON"] = "America/Edmonton";
  TimeZones2["AMERICA_EIRUNEPE"] = "America/Eirunepe";
  TimeZones2["AMERICA_EL_SALVADOR"] = "America/El_Salvador";
  TimeZones2["AMERICA_ENSENADA"] = "America/Ensenada";
  TimeZones2["AMERICA_FORT_NELSON"] = "America/Fort_Nelson";
  TimeZones2["AMERICA_FORT_WAYNE"] = "America/Fort_Wayne";
  TimeZones2["AMERICA_FORTALEZA"] = "America/Fortaleza";
  TimeZones2["AMERICA_GLACE_BAY"] = "America/Glace_Bay";
  TimeZones2["AMERICA_GODTHAB"] = "America/Godthab";
  TimeZones2["AMERICA_GOOSE_BAY"] = "America/Goose_Bay";
  TimeZones2["AMERICA_GRAND_TURK"] = "America/Grand_Turk";
  TimeZones2["AMERICA_GRENADA"] = "America/Grenada";
  TimeZones2["AMERICA_GUADELOUPE"] = "America/Guadeloupe";
  TimeZones2["AMERICA_GUATEMALA"] = "America/Guatemala";
  TimeZones2["AMERICA_GUAYAQUIL"] = "America/Guayaquil";
  TimeZones2["AMERICA_GUYANA"] = "America/Guyana";
  TimeZones2["AMERICA_HALIFAX"] = "America/Halifax";
  TimeZones2["AMERICA_HAVANA"] = "America/Havana";
  TimeZones2["AMERICA_HERMOSILLO"] = "America/Hermosillo";
  TimeZones2["AMERICA_INDIANA_INDIANAPOLIS"] = "America/Indiana/Indianapolis";
  TimeZones2["AMERICA_INDIANA_KNOX"] = "America/Indiana/Knox";
  TimeZones2["AMERICA_INDIANA_MARENGO"] = "America/Indiana/Marengo";
  TimeZones2["AMERICA_INDIANA_PETERSBURG"] = "America/Indiana/Petersburg";
  TimeZones2["AMERICA_INDIANA_TELL_CITY"] = "America/Indiana/Tell_City";
  TimeZones2["AMERICA_INDIANA_VEVAY"] = "America/Indiana/Vevay";
  TimeZones2["AMERICA_INDIANA_VINCENNES"] = "America/Indiana/Vincennes";
  TimeZones2["AMERICA_INDIANA_WINAMAC"] = "America/Indiana/Winamac";
  TimeZones2["AMERICA_INDIANAPOLIS"] = "America/Indianapolis";
  TimeZones2["AMERICA_INUVIK"] = "America/Inuvik";
  TimeZones2["AMERICA_IQALUIT"] = "America/Iqaluit";
  TimeZones2["AMERICA_JAMAICA"] = "America/Jamaica";
  TimeZones2["AMERICA_JUJUY"] = "America/Jujuy";
  TimeZones2["AMERICA_JUNEAU"] = "America/Juneau";
  TimeZones2["AMERICA_KENTUCKY_LOUISVILLE"] = "America/Kentucky/Louisville";
  TimeZones2["AMERICA_KENTUCKY_MONTICELLO"] = "America/Kentucky/Monticello";
  TimeZones2["AMERICA_KNOX_IN"] = "America/Knox_IN";
  TimeZones2["AMERICA_KRALENDIJK"] = "America/Kralendijk";
  TimeZones2["AMERICA_LA_PAZ"] = "America/La_Paz";
  TimeZones2["AMERICA_LIMA"] = "America/Lima";
  TimeZones2["AMERICA_LOS_ANGELES"] = "America/Los_Angeles";
  TimeZones2["AMERICA_LOUISVILLE"] = "America/Louisville";
  TimeZones2["AMERICA_LOWER_PRINCES"] = "America/Lower_Princes";
  TimeZones2["AMERICA_MACEIO"] = "America/Maceio";
  TimeZones2["AMERICA_MANAGUA"] = "America/Managua";
  TimeZones2["AMERICA_MANAUS"] = "America/Manaus";
  TimeZones2["AMERICA_MARIGOT"] = "America/Marigot";
  TimeZones2["AMERICA_MARTINIQUE"] = "America/Martinique";
  TimeZones2["AMERICA_MATAMOROS"] = "America/Matamoros";
  TimeZones2["AMERICA_MAZATLAN"] = "America/Mazatlan";
  TimeZones2["AMERICA_MENDOZA"] = "America/Mendoza";
  TimeZones2["AMERICA_MENOMINEE"] = "America/Menominee";
  TimeZones2["AMERICA_MERIDA"] = "America/Merida";
  TimeZones2["AMERICA_METLAKATLA"] = "America/Metlakatla";
  TimeZones2["AMERICA_MEXICO_CITY"] = "America/Mexico_City";
  TimeZones2["AMERICA_MIQUELON"] = "America/Miquelon";
  TimeZones2["AMERICA_MONCTON"] = "America/Moncton";
  TimeZones2["AMERICA_MONTERREY"] = "America/Monterrey";
  TimeZones2["AMERICA_MONTEVIDEO"] = "America/Montevideo";
  TimeZones2["AMERICA_MONTREAL"] = "America/Montreal";
  TimeZones2["AMERICA_MONTSERRAT"] = "America/Montserrat";
  TimeZones2["AMERICA_NASSAU"] = "America/Nassau";
  TimeZones2["AMERICA_NEW_YORK"] = "America/New_York";
  TimeZones2["AMERICA_NIPIGON"] = "America/Nipigon";
  TimeZones2["AMERICA_NOME"] = "America/Nome";
  TimeZones2["AMERICA_NORONHA"] = "America/Noronha";
  TimeZones2["AMERICA_NORTH_DAKOTA_BEULAH"] = "America/North_Dakota/Beulah";
  TimeZones2["AMERICA_NORTH_DAKOTA_CENTER"] = "America/North_Dakota/Center";
  TimeZones2["AMERICA_NORTH_DAKOTA_NEW_SALEM"] = "America/North_Dakota/New_Salem";
  TimeZones2["AMERICA_NUUK"] = "America/Nuuk";
  TimeZones2["AMERICA_OJINAGA"] = "America/Ojinaga";
  TimeZones2["AMERICA_PANAMA"] = "America/Panama";
  TimeZones2["AMERICA_PANGNIRTUNG"] = "America/Pangnirtung";
  TimeZones2["AMERICA_PARAMARIBO"] = "America/Paramaribo";
  TimeZones2["AMERICA_PHOENIX"] = "America/Phoenix";
  TimeZones2["AMERICA_PORT_AU_PRINCE"] = "America/Port-au-Prince";
  TimeZones2["AMERICA_PORT_OF_SPAIN"] = "America/Port_of_Spain";
  TimeZones2["AMERICA_PORTO_ACRE"] = "America/Porto_Acre";
  TimeZones2["AMERICA_PORTO_VELHO"] = "America/Porto_Velho";
  TimeZones2["AMERICA_PUERTO_RICO"] = "America/Puerto_Rico";
  TimeZones2["AMERICA_PUNTA_ARENAS"] = "America/Punta_Arenas";
  TimeZones2["AMERICA_RAINY_RIVER"] = "America/Rainy_River";
  TimeZones2["AMERICA_RANKIN_INLET"] = "America/Rankin_Inlet";
  TimeZones2["AMERICA_RECIFE"] = "America/Recife";
  TimeZones2["AMERICA_REGINA"] = "America/Regina";
  TimeZones2["AMERICA_RESOLUTE"] = "America/Resolute";
  TimeZones2["AMERICA_RIO_BRANCO"] = "America/Rio_Branco";
  TimeZones2["AMERICA_ROSARIO"] = "America/Rosario";
  TimeZones2["AMERICA_SANTA_ISABEL"] = "America/Santa_Isabel";
  TimeZones2["AMERICA_SANTAREM"] = "America/Santarem";
  TimeZones2["AMERICA_SANTIAGO"] = "America/Santiago";
  TimeZones2["AMERICA_SANTO_DOMINGO"] = "America/Santo_Domingo";
  TimeZones2["AMERICA_SAO_PAULO"] = "America/Sao_Paulo";
  TimeZones2["AMERICA_SCORESBYSUND"] = "America/Scoresbysund";
  TimeZones2["AMERICA_SHIPROCK"] = "America/Shiprock";
  TimeZones2["AMERICA_SITKA"] = "America/Sitka";
  TimeZones2["AMERICA_ST_BARTHELEMY"] = "America/St_Barthelemy";
  TimeZones2["AMERICA_ST_JOHNS"] = "America/St_Johns";
  TimeZones2["AMERICA_ST_KITTS"] = "America/St_Kitts";
  TimeZones2["AMERICA_ST_LUCIA"] = "America/St_Lucia";
  TimeZones2["AMERICA_ST_THOMAS"] = "America/St_Thomas";
  TimeZones2["AMERICA_ST_VINCENT"] = "America/St_Vincent";
  TimeZones2["AMERICA_SWIFT_CURRENT"] = "America/Swift_Current";
  TimeZones2["AMERICA_TEGUCIGALPA"] = "America/Tegucigalpa";
  TimeZones2["AMERICA_THULE"] = "America/Thule";
  TimeZones2["AMERICA_THUNDER_BAY"] = "America/Thunder_Bay";
  TimeZones2["AMERICA_TIJUANA"] = "America/Tijuana";
  TimeZones2["AMERICA_TORONTO"] = "America/Toronto";
  TimeZones2["AMERICA_TORTOLA"] = "America/Tortola";
  TimeZones2["AMERICA_VANCOUVER"] = "America/Vancouver";
  TimeZones2["AMERICA_VIRGIN"] = "America/Virgin";
  TimeZones2["AMERICA_WHITEHORSE"] = "America/Whitehorse";
  TimeZones2["AMERICA_WINNIPEG"] = "America/Winnipeg";
  TimeZones2["AMERICA_YAKUTAT"] = "America/Yakutat";
  TimeZones2["AMERICA_YELLOWKNIFE"] = "America/Yellowknife";
  TimeZones2["ANTARCTICA_CASEY"] = "Antarctica/Casey";
  TimeZones2["ANTARCTICA_DAVIS"] = "Antarctica/Davis";
  TimeZones2["ANTARCTICA_DUMONT_D_URVILLE"] = "Antarctica/DumontDUrville";
  TimeZones2["ANTARCTICA_MACQUARIE"] = "Antarctica/Macquarie";
  TimeZones2["ANTARCTICA_MAWSON"] = "Antarctica/Mawson";
  TimeZones2["ANTARCTICA_MC_MURDO"] = "Antarctica/McMurdo";
  TimeZones2["ANTARCTICA_PALMER"] = "Antarctica/Palmer";
  TimeZones2["ANTARCTICA_ROTHERA"] = "Antarctica/Rothera";
  TimeZones2["ANTARCTICA_SOUTH_POLE"] = "Antarctica/South_Pole";
  TimeZones2["ANTARCTICA_SYOWA"] = "Antarctica/Syowa";
  TimeZones2["ANTARCTICA_TROLL"] = "Antarctica/Troll";
  TimeZones2["ANTARCTICA_VOSTOK"] = "Antarctica/Vostok";
  TimeZones2["ARCTIC_LONGYEARBYEN"] = "Arctic/Longyearbyen";
  TimeZones2["ASIA_ADEN"] = "Asia/Aden";
  TimeZones2["ASIA_ALMATY"] = "Asia/Almaty";
  TimeZones2["ASIA_AMMAN"] = "Asia/Amman";
  TimeZones2["ASIA_ANADYR"] = "Asia/Anadyr";
  TimeZones2["ASIA_AQTAU"] = "Asia/Aqtau";
  TimeZones2["ASIA_AQTOBE"] = "Asia/Aqtobe";
  TimeZones2["ASIA_ASHGABAT"] = "Asia/Ashgabat";
  TimeZones2["ASIA_ASHKHABAD"] = "Asia/Ashkhabad";
  TimeZones2["ASIA_ATYRAU"] = "Asia/Atyrau";
  TimeZones2["ASIA_BAGHDAD"] = "Asia/Baghdad";
  TimeZones2["ASIA_BAHRAIN"] = "Asia/Bahrain";
  TimeZones2["ASIA_BAKU"] = "Asia/Baku";
  TimeZones2["ASIA_BANGKOK"] = "Asia/Bangkok";
  TimeZones2["ASIA_BARNAUL"] = "Asia/Barnaul";
  TimeZones2["ASIA_BEIRUT"] = "Asia/Beirut";
  TimeZones2["ASIA_BISHKEK"] = "Asia/Bishkek";
  TimeZones2["ASIA_BRUNEI"] = "Asia/Brunei";
  TimeZones2["ASIA_CALCUTTA"] = "Asia/Calcutta";
  TimeZones2["ASIA_CHITA"] = "Asia/Chita";
  TimeZones2["ASIA_CHOIBALSAN"] = "Asia/Choibalsan";
  TimeZones2["ASIA_CHONGQING"] = "Asia/Chongqing";
  TimeZones2["ASIA_CHUNGKING"] = "Asia/Chungking";
  TimeZones2["ASIA_COLOMBO"] = "Asia/Colombo";
  TimeZones2["ASIA_DACCA"] = "Asia/Dacca";
  TimeZones2["ASIA_DAMASCUS"] = "Asia/Damascus";
  TimeZones2["ASIA_DHAKA"] = "Asia/Dhaka";
  TimeZones2["ASIA_DILI"] = "Asia/Dili";
  TimeZones2["ASIA_DUBAI"] = "Asia/Dubai";
  TimeZones2["ASIA_DUSHANBE"] = "Asia/Dushanbe";
  TimeZones2["ASIA_FAMAGUSTA"] = "Asia/Famagusta";
  TimeZones2["ASIA_GAZA"] = "Asia/Gaza";
  TimeZones2["ASIA_HARBIN"] = "Asia/Harbin";
  TimeZones2["ASIA_HEBRON"] = "Asia/Hebron";
  TimeZones2["ASIA_HO_CHI_MINH"] = "Asia/Ho_Chi_Minh";
  TimeZones2["ASIA_HONG_KONG"] = "Asia/Hong_Kong";
  TimeZones2["ASIA_HOVD"] = "Asia/Hovd";
  TimeZones2["ASIA_IRKUTSK"] = "Asia/Irkutsk";
  TimeZones2["ASIA_ISTANBUL"] = "Asia/Istanbul";
  TimeZones2["ASIA_JAKARTA"] = "Asia/Jakarta";
  TimeZones2["ASIA_JAYAPURA"] = "Asia/Jayapura";
  TimeZones2["ASIA_JERUSALEM"] = "Asia/Jerusalem";
  TimeZones2["ASIA_KABUL"] = "Asia/Kabul";
  TimeZones2["ASIA_KAMCHATKA"] = "Asia/Kamchatka";
  TimeZones2["ASIA_KARACHI"] = "Asia/Karachi";
  TimeZones2["ASIA_KASHGAR"] = "Asia/Kashgar";
  TimeZones2["ASIA_KATHMANDU"] = "Asia/Kathmandu";
  TimeZones2["ASIA_KATMANDU"] = "Asia/Katmandu";
  TimeZones2["ASIA_KHANDYGA"] = "Asia/Khandyga";
  TimeZones2["ASIA_KOLKATA"] = "Asia/Kolkata";
  TimeZones2["ASIA_KRASNOYARSK"] = "Asia/Krasnoyarsk";
  TimeZones2["ASIA_KUALA_LUMPUR"] = "Asia/Kuala_Lumpur";
  TimeZones2["ASIA_KUCHING"] = "Asia/Kuching";
  TimeZones2["ASIA_KUWAIT"] = "Asia/Kuwait";
  TimeZones2["ASIA_MACAO"] = "Asia/Macao";
  TimeZones2["ASIA_MACAU"] = "Asia/Macau";
  TimeZones2["ASIA_MAGADAN"] = "Asia/Magadan";
  TimeZones2["ASIA_MAKASSAR"] = "Asia/Makassar";
  TimeZones2["ASIA_MANILA"] = "Asia/Manila";
  TimeZones2["ASIA_MUSCAT"] = "Asia/Muscat";
  TimeZones2["ASIA_NICOSIA"] = "Asia/Nicosia";
  TimeZones2["ASIA_NOVOKUZNETSK"] = "Asia/Novokuznetsk";
  TimeZones2["ASIA_NOVOSIBIRSK"] = "Asia/Novosibirsk";
  TimeZones2["ASIA_OMSK"] = "Asia/Omsk";
  TimeZones2["ASIA_ORAL"] = "Asia/Oral";
  TimeZones2["ASIA_PHNOM_PENH"] = "Asia/Phnom_Penh";
  TimeZones2["ASIA_PONTIANAK"] = "Asia/Pontianak";
  TimeZones2["ASIA_PYONGYANG"] = "Asia/Pyongyang";
  TimeZones2["ASIA_QATAR"] = "Asia/Qatar";
  TimeZones2["ASIA_QOSTANAY"] = "Asia/Qostanay";
  TimeZones2["ASIA_QYZYLORDA"] = "Asia/Qyzylorda";
  TimeZones2["ASIA_RANGOON"] = "Asia/Rangoon";
  TimeZones2["ASIA_RIYADH"] = "Asia/Riyadh";
  TimeZones2["ASIA_SAIGON"] = "Asia/Saigon";
  TimeZones2["ASIA_SAKHALIN"] = "Asia/Sakhalin";
  TimeZones2["ASIA_SAMARKAND"] = "Asia/Samarkand";
  TimeZones2["ASIA_SEOUL"] = "Asia/Seoul";
  TimeZones2["ASIA_SHANGHAI"] = "Asia/Shanghai";
  TimeZones2["ASIA_SINGAPORE"] = "Asia/Singapore";
  TimeZones2["ASIA_SREDNEKOLYMSK"] = "Asia/Srednekolymsk";
  TimeZones2["ASIA_TAIPEI"] = "Asia/Taipei";
  TimeZones2["ASIA_TASHKENT"] = "Asia/Tashkent";
  TimeZones2["ASIA_TBILISI"] = "Asia/Tbilisi";
  TimeZones2["ASIA_TEHRAN"] = "Asia/Tehran";
  TimeZones2["ASIA_TEL_AVIV"] = "Asia/Tel_Aviv";
  TimeZones2["ASIA_THIMBU"] = "Asia/Thimbu";
  TimeZones2["ASIA_THIMPHU"] = "Asia/Thimphu";
  TimeZones2["ASIA_TOKYO"] = "Asia/Tokyo";
  TimeZones2["ASIA_TOMSK"] = "Asia/Tomsk";
  TimeZones2["ASIA_UJUNG_PANDANG"] = "Asia/Ujung_Pandang";
  TimeZones2["ASIA_ULAANBAATAR"] = "Asia/Ulaanbaatar";
  TimeZones2["ASIA_ULAN_BATOR"] = "Asia/Ulan_Bator";
  TimeZones2["ASIA_URUMQI"] = "Asia/Urumqi";
  TimeZones2["ASIA_UST_NERA"] = "Asia/Ust-Nera";
  TimeZones2["ASIA_VIENTIANE"] = "Asia/Vientiane";
  TimeZones2["ASIA_VLADIVOSTOK"] = "Asia/Vladivostok";
  TimeZones2["ASIA_YAKUTSK"] = "Asia/Yakutsk";
  TimeZones2["ASIA_YANGON"] = "Asia/Yangon";
  TimeZones2["ASIA_YEKATERINBURG"] = "Asia/Yekaterinburg";
  TimeZones2["ASIA_YEREVAN"] = "Asia/Yerevan";
  TimeZones2["ATLANTIC_AZORES"] = "Atlantic/Azores";
  TimeZones2["ATLANTIC_BERMUDA"] = "Atlantic/Bermuda";
  TimeZones2["ATLANTIC_CANARY"] = "Atlantic/Canary";
  TimeZones2["ATLANTIC_CAPE_VERDE"] = "Atlantic/Cape_Verde";
  TimeZones2["ATLANTIC_FAEROE"] = "Atlantic/Faeroe";
  TimeZones2["ATLANTIC_FAROE"] = "Atlantic/Faroe";
  TimeZones2["ATLANTIC_JAN_MAYEN"] = "Atlantic/Jan_Mayen";
  TimeZones2["ATLANTIC_MADEIRA"] = "Atlantic/Madeira";
  TimeZones2["ATLANTIC_REYKJAVIK"] = "Atlantic/Reykjavik";
  TimeZones2["ATLANTIC_SOUTH_GEORGIA"] = "Atlantic/South_Georgia";
  TimeZones2["ATLANTIC_ST_HELENA"] = "Atlantic/St_Helena";
  TimeZones2["ATLANTIC_STANLEY"] = "Atlantic/Stanley";
  TimeZones2["AUSTRALIA_ACT"] = "Australia/ACT";
  TimeZones2["AUSTRALIA_ADELAIDE"] = "Australia/Adelaide";
  TimeZones2["AUSTRALIA_BRISBANE"] = "Australia/Brisbane";
  TimeZones2["AUSTRALIA_BROKEN_HILL"] = "Australia/Broken_Hill";
  TimeZones2["AUSTRALIA_CANBERRA"] = "Australia/Canberra";
  TimeZones2["AUSTRALIA_CURRIE"] = "Australia/Currie";
  TimeZones2["AUSTRALIA_DARWIN"] = "Australia/Darwin";
  TimeZones2["AUSTRALIA_EUCLA"] = "Australia/Eucla";
  TimeZones2["AUSTRALIA_HOBART"] = "Australia/Hobart";
  TimeZones2["AUSTRALIA_LHI"] = "Australia/LHI";
  TimeZones2["AUSTRALIA_LINDEMAN"] = "Australia/Lindeman";
  TimeZones2["AUSTRALIA_LORD_HOWE"] = "Australia/Lord_Howe";
  TimeZones2["AUSTRALIA_MELBOURNE"] = "Australia/Melbourne";
  TimeZones2["AUSTRALIA_NSW"] = "Australia/NSW";
  TimeZones2["AUSTRALIA_NORTH"] = "Australia/North";
  TimeZones2["AUSTRALIA_PERTH"] = "Australia/Perth";
  TimeZones2["AUSTRALIA_QUEENSLAND"] = "Australia/Queensland";
  TimeZones2["AUSTRALIA_SOUTH"] = "Australia/South";
  TimeZones2["AUSTRALIA_SYDNEY"] = "Australia/Sydney";
  TimeZones2["AUSTRALIA_TASMANIA"] = "Australia/Tasmania";
  TimeZones2["AUSTRALIA_VICTORIA"] = "Australia/Victoria";
  TimeZones2["AUSTRALIA_WEST"] = "Australia/West";
  TimeZones2["AUSTRALIA_YANCOWINNA"] = "Australia/Yancowinna";
  TimeZones2["BRAZIL_ACRE"] = "Brazil/Acre";
  TimeZones2["BRAZIL_DE_NORONHA"] = "Brazil/DeNoronha";
  TimeZones2["BRAZIL_EAST"] = "Brazil/East";
  TimeZones2["BRAZIL_WEST"] = "Brazil/West";
  TimeZones2["CET"] = "CET";
  TimeZones2["CST6CDT"] = "CST6CDT";
  TimeZones2["CANADA_ATLANTIC"] = "Canada/Atlantic";
  TimeZones2["CANADA_CENTRAL"] = "Canada/Central";
  TimeZones2["CANADA_EASTERN"] = "Canada/Eastern";
  TimeZones2["CANADA_MOUNTAIN"] = "Canada/Mountain";
  TimeZones2["CANADA_NEWFOUNDLAND"] = "Canada/Newfoundland";
  TimeZones2["CANADA_PACIFIC"] = "Canada/Pacific";
  TimeZones2["CANADA_SASKATCHEWAN"] = "Canada/Saskatchewan";
  TimeZones2["CANADA_YUKON"] = "Canada/Yukon";
  TimeZones2["CHILE_CONTINENTAL"] = "Chile/Continental";
  TimeZones2["CHILE_EASTER_ISLAND"] = "Chile/EasterIsland";
  TimeZones2["CUBA"] = "Cuba";
  TimeZones2["EET"] = "EET";
  TimeZones2["EST"] = "EST";
  TimeZones2["EST5EDT"] = "EST5EDT";
  TimeZones2["EGYPT"] = "Egypt";
  TimeZones2["EIRE"] = "Eire";
  TimeZones2["EUROPE_AMSTERDAM"] = "Europe/Amsterdam";
  TimeZones2["EUROPE_ANDORRA"] = "Europe/Andorra";
  TimeZones2["EUROPE_ASTRAKHAN"] = "Europe/Astrakhan";
  TimeZones2["EUROPE_ATHENS"] = "Europe/Athens";
  TimeZones2["EUROPE_BELFAST"] = "Europe/Belfast";
  TimeZones2["EUROPE_BELGRADE"] = "Europe/Belgrade";
  TimeZones2["EUROPE_BERLIN"] = "Europe/Berlin";
  TimeZones2["EUROPE_BRATISLAVA"] = "Europe/Bratislava";
  TimeZones2["EUROPE_BRUSSELS"] = "Europe/Brussels";
  TimeZones2["EUROPE_BUCHAREST"] = "Europe/Bucharest";
  TimeZones2["EUROPE_BUDAPEST"] = "Europe/Budapest";
  TimeZones2["EUROPE_BUSINGEN"] = "Europe/Busingen";
  TimeZones2["EUROPE_CHISINAU"] = "Europe/Chisinau";
  TimeZones2["EUROPE_COPENHAGEN"] = "Europe/Copenhagen";
  TimeZones2["EUROPE_DUBLIN"] = "Europe/Dublin";
  TimeZones2["EUROPE_GIBRALTAR"] = "Europe/Gibraltar";
  TimeZones2["EUROPE_GUERNSEY"] = "Europe/Guernsey";
  TimeZones2["EUROPE_HELSINKI"] = "Europe/Helsinki";
  TimeZones2["EUROPE_ISLE_OF_MAN"] = "Europe/Isle_of_Man";
  TimeZones2["EUROPE_ISTANBUL"] = "Europe/Istanbul";
  TimeZones2["EUROPE_JERSEY"] = "Europe/Jersey";
  TimeZones2["EUROPE_KALININGRAD"] = "Europe/Kaliningrad";
  TimeZones2["EUROPE_KIEV"] = "Europe/Kiev";
  TimeZones2["EUROPE_KIROV"] = "Europe/Kirov";
  TimeZones2["EUROPE_KYIV"] = "Europe/Kyiv";
  TimeZones2["EUROPE_LISBON"] = "Europe/Lisbon";
  TimeZones2["EUROPE_LJUBLJANA"] = "Europe/Ljubljana";
  TimeZones2["EUROPE_LONDON"] = "Europe/London";
  TimeZones2["EUROPE_LUXEMBOURG"] = "Europe/Luxembourg";
  TimeZones2["EUROPE_MADRID"] = "Europe/Madrid";
  TimeZones2["EUROPE_MALTA"] = "Europe/Malta";
  TimeZones2["EUROPE_MARIEHAMN"] = "Europe/Mariehamn";
  TimeZones2["EUROPE_MINSK"] = "Europe/Minsk";
  TimeZones2["EUROPE_MONACO"] = "Europe/Monaco";
  TimeZones2["EUROPE_MOSCOW"] = "Europe/Moscow";
  TimeZones2["EUROPE_NICOSIA"] = "Europe/Nicosia";
  TimeZones2["EUROPE_OSLO"] = "Europe/Oslo";
  TimeZones2["EUROPE_PARIS"] = "Europe/Paris";
  TimeZones2["EUROPE_PODGORICA"] = "Europe/Podgorica";
  TimeZones2["EUROPE_PRAGUE"] = "Europe/Prague";
  TimeZones2["EUROPE_RIGA"] = "Europe/Riga";
  TimeZones2["EUROPE_ROME"] = "Europe/Rome";
  TimeZones2["EUROPE_SAMARA"] = "Europe/Samara";
  TimeZones2["EUROPE_SAN_MARINO"] = "Europe/San_Marino";
  TimeZones2["EUROPE_SARAJEVO"] = "Europe/Sarajevo";
  TimeZones2["EUROPE_SARATOV"] = "Europe/Saratov";
  TimeZones2["EUROPE_SIMFEROPOL"] = "Europe/Simferopol";
  TimeZones2["EUROPE_SKOPJE"] = "Europe/Skopje";
  TimeZones2["EUROPE_SOFIA"] = "Europe/Sofia";
  TimeZones2["EUROPE_STOCKHOLM"] = "Europe/Stockholm";
  TimeZones2["EUROPE_TALLINN"] = "Europe/Tallinn";
  TimeZones2["EUROPE_TIRANE"] = "Europe/Tirane";
  TimeZones2["EUROPE_TIRASPOL"] = "Europe/Tiraspol";
  TimeZones2["EUROPE_ULYANOVSK"] = "Europe/Ulyanovsk";
  TimeZones2["EUROPE_UZHGOROD"] = "Europe/Uzhgorod";
  TimeZones2["EUROPE_VADUZ"] = "Europe/Vaduz";
  TimeZones2["EUROPE_VATICAN"] = "Europe/Vatican";
  TimeZones2["EUROPE_VIENNA"] = "Europe/Vienna";
  TimeZones2["EUROPE_VILNIUS"] = "Europe/Vilnius";
  TimeZones2["EUROPE_VOLGOGRAD"] = "Europe/Volgograd";
  TimeZones2["EUROPE_WARSAW"] = "Europe/Warsaw";
  TimeZones2["EUROPE_ZAGREB"] = "Europe/Zagreb";
  TimeZones2["EUROPE_ZAPOROZHYE"] = "Europe/Zaporozhye";
  TimeZones2["EUROPE_ZURICH"] = "Europe/Zurich";
  TimeZones2["GB"] = "GB";
  TimeZones2["GMT"] = "GMT";
  TimeZones2["GREENWICH"] = "Greenwich";
  TimeZones2["HST"] = "HST";
  TimeZones2["HONGKONG"] = "Hongkong";
  TimeZones2["ICELAND"] = "Iceland";
  TimeZones2["INDIAN_ANTANANARIVO"] = "Indian/Antananarivo";
  TimeZones2["INDIAN_CHAGOS"] = "Indian/Chagos";
  TimeZones2["INDIAN_CHRISTMAS"] = "Indian/Christmas";
  TimeZones2["INDIAN_COCOS"] = "Indian/Cocos";
  TimeZones2["INDIAN_COMORO"] = "Indian/Comoro";
  TimeZones2["INDIAN_KERGUELEN"] = "Indian/Kerguelen";
  TimeZones2["INDIAN_MAHE"] = "Indian/Mahe";
  TimeZones2["INDIAN_MALDIVES"] = "Indian/Maldives";
  TimeZones2["INDIAN_MAURITIUS"] = "Indian/Mauritius";
  TimeZones2["INDIAN_MAYOTTE"] = "Indian/Mayotte";
  TimeZones2["INDIAN_REUNION"] = "Indian/Reunion";
  TimeZones2["IRAN"] = "Iran";
  TimeZones2["ISRAEL"] = "Israel";
  TimeZones2["JAMAICA"] = "Jamaica";
  TimeZones2["JAPAN"] = "Japan";
  TimeZones2["KWAJALEIN"] = "Kwajalein";
  TimeZones2["LIBYA"] = "Libya";
  TimeZones2["MET"] = "MET";
  TimeZones2["MST"] = "MST";
  TimeZones2["MST7MDT"] = "MST7MDT";
  TimeZones2["MEXICO_BAJA_NORTE"] = "Mexico/BajaNorte";
  TimeZones2["MEXICO_BAJA_SUR"] = "Mexico/BajaSur";
  TimeZones2["MEXICO_GENERAL"] = "Mexico/General";
  TimeZones2["NZ"] = "NZ";
  TimeZones2["NZ_CHAT"] = "NZ-CHAT";
  TimeZones2["NAVAJO"] = "Navajo";
  TimeZones2["PRC"] = "PRC";
  TimeZones2["PST8PDT"] = "PST8PDT";
  TimeZones2["PACIFIC_APIA"] = "Pacific/Apia";
  TimeZones2["PACIFIC_AUCKLAND"] = "Pacific/Auckland";
  TimeZones2["PACIFIC_BOUGAINVILLE"] = "Pacific/Bougainville";
  TimeZones2["PACIFIC_CHATHAM"] = "Pacific/Chatham";
  TimeZones2["PACIFIC_CHUUK"] = "Pacific/Chuuk";
  TimeZones2["PACIFIC_EASTER"] = "Pacific/Easter";
  TimeZones2["PACIFIC_EFATE"] = "Pacific/Efate";
  TimeZones2["PACIFIC_ENDERBURY"] = "Pacific/Enderbury";
  TimeZones2["PACIFIC_FAKAOFO"] = "Pacific/Fakaofo";
  TimeZones2["PACIFIC_FIJI"] = "Pacific/Fiji";
  TimeZones2["PACIFIC_FUNAFUTI"] = "Pacific/Funafuti";
  TimeZones2["PACIFIC_GALAPAGOS"] = "Pacific/Galapagos";
  TimeZones2["PACIFIC_GAMBIER"] = "Pacific/Gambier";
  TimeZones2["PACIFIC_GUADALCANAL"] = "Pacific/Guadalcanal";
  TimeZones2["PACIFIC_GUAM"] = "Pacific/Guam";
  TimeZones2["PACIFIC_HONOLULU"] = "Pacific/Honolulu";
  TimeZones2["PACIFIC_JOHNSTON"] = "Pacific/Johnston";
  TimeZones2["PACIFIC_KANTON"] = "Pacific/Kanton";
  TimeZones2["PACIFIC_KIRITIMATI"] = "Pacific/Kiritimati";
  TimeZones2["PACIFIC_KOSRAE"] = "Pacific/Kosrae";
  TimeZones2["PACIFIC_KWAJALEIN"] = "Pacific/Kwajalein";
  TimeZones2["PACIFIC_MAJURO"] = "Pacific/Majuro";
  TimeZones2["PACIFIC_MARQUESAS"] = "Pacific/Marquesas";
  TimeZones2["PACIFIC_MIDWAY"] = "Pacific/Midway";
  TimeZones2["PACIFIC_NAURU"] = "Pacific/Nauru";
  TimeZones2["PACIFIC_NIUE"] = "Pacific/Niue";
  TimeZones2["PACIFIC_NORFOLK"] = "Pacific/Norfolk";
  TimeZones2["PACIFIC_NOUMEA"] = "Pacific/Noumea";
  TimeZones2["PACIFIC_PAGO_PAGO"] = "Pacific/Pago_Pago";
  TimeZones2["PACIFIC_PALAU"] = "Pacific/Palau";
  TimeZones2["PACIFIC_PITCAIRN"] = "Pacific/Pitcairn";
  TimeZones2["PACIFIC_POHNPEI"] = "Pacific/Pohnpei";
  TimeZones2["PACIFIC_PONAPE"] = "Pacific/Ponape";
  TimeZones2["PACIFIC_PORT_MORESBY"] = "Pacific/Port_Moresby";
  TimeZones2["PACIFIC_RAROTONGA"] = "Pacific/Rarotonga";
  TimeZones2["PACIFIC_SAIPAN"] = "Pacific/Saipan";
  TimeZones2["PACIFIC_SAMOA"] = "Pacific/Samoa";
  TimeZones2["PACIFIC_TAHITI"] = "Pacific/Tahiti";
  TimeZones2["PACIFIC_TARAWA"] = "Pacific/Tarawa";
  TimeZones2["PACIFIC_TONGATAPU"] = "Pacific/Tongatapu";
  TimeZones2["PACIFIC_TRUK"] = "Pacific/Truk";
  TimeZones2["PACIFIC_WAKE"] = "Pacific/Wake";
  TimeZones2["PACIFIC_WALLIS"] = "Pacific/Wallis";
  TimeZones2["PACIFIC_YAP"] = "Pacific/Yap";
  TimeZones2["POLAND"] = "Poland";
  TimeZones2["PORTUGAL"] = "Portugal";
  TimeZones2["ROC"] = "ROC";
  TimeZones2["ROK"] = "ROK";
  TimeZones2["SINGAPORE"] = "Singapore";
  TimeZones2["TURKEY"] = "Turkey";
  TimeZones2["UCT"] = "UCT";
  TimeZones2["US_ALASKA"] = "US/Alaska";
  TimeZones2["US_ALEUTIAN"] = "US/Aleutian";
  TimeZones2["US_ARIZONA"] = "US/Arizona";
  TimeZones2["US_CENTRAL"] = "US/Central";
  TimeZones2["US_EAST_INDIANA"] = "US/East-Indiana";
  TimeZones2["US_EASTERN"] = "US/Eastern";
  TimeZones2["US_HAWAII"] = "US/Hawaii";
  TimeZones2["US_INDIANA_STARKE"] = "US/Indiana-Starke";
  TimeZones2["US_MICHIGAN"] = "US/Michigan";
  TimeZones2["US_MOUNTAIN"] = "US/Mountain";
  TimeZones2["US_PACIFIC"] = "US/Pacific";
  TimeZones2["US_SAMOA"] = "US/Samoa";
  TimeZones2["UTC"] = "UTC";
  TimeZones2["UNIVERSAL"] = "Universal";
  TimeZones2["W_SU"] = "W-SU";
  TimeZones2["WET"] = "WET";
  TimeZones2["ZULU"] = "Zulu";
  TimeZones2["LOCALTIME"] = "localtime";
  return TimeZones2;
})(TimeZones || {});
var UserFieldId = /* @__PURE__ */ ((UserFieldId2) => {
  UserFieldId2["ID"] = "id";
  UserFieldId2["EMAIL"] = "email";
  UserFieldId2["NAME"] = "name";
  UserFieldId2["INSERTED_AT"] = "insertedAt";
  UserFieldId2["UPDATED_AT"] = "updatedAt";
  return UserFieldId2;
})(UserFieldId || {});
var VATType = /* @__PURE__ */ ((VATType2) => {
  VATType2["INPUT_TAX_INVESTMENTS_OPERATING_EXPENSES"] = "input_tax_investments_operating_expenses";
  VATType2["INPUT_TAX_MATERIALS_GOODS_SERVICES_ENERGY"] = "input_tax_materials_goods_services_energy";
  VATType2["PREPAID_VAT_INVESTMENTS_OPERATING_EXPENSES"] = "prepaid_vat_investments_operating_expenses";
  VATType2["PREPAID_VAT_MATERIALS_GOODS_SERVICES_ENERGY"] = "prepaid_vat_materials_goods_services_energy";
  VATType2["CUSTOMS_TAX_INVESTMENTS_OPERATING_EXPENSES"] = "customs_tax_investments_operating_expenses";
  VATType2["CUSTOMS_TAX_MATERIALS_GOODS_SERVICES_ENERGY"] = "customs_tax_materials_goods_services_energy";
  VATType2["OWED_VAT_SALES_TAX"] = "owed_vat_sales_tax";
  VATType2["OPTED_OWED_VAT_SALES_TAX"] = "opted_owed_vat_sales_tax";
  VATType2["NON_CONSIDERATION"] = "non_consideration";
  VATType2["NON_TAXABLE_REVENUE"] = "non_taxable_revenue";
  return VATType2;
})(VATType || {});
var VatCalculationBasis = /* @__PURE__ */ ((VatCalculationBasis2) => {
  VatCalculationBasis2["ACCRUAL"] = "accrual";
  VatCalculationBasis2["CASH"] = "cash";
  return VatCalculationBasis2;
})(VatCalculationBasis || {});
var VatSuperType = /* @__PURE__ */ ((VatSuperType2) => {
  VatSuperType2["OWED"] = "owed";
  VatSuperType2["BENEFIT"] = "benefit";
  VatSuperType2["PASSTHROUGH"] = "passthrough";
  VatSuperType2["NONE"] = "none";
  return VatSuperType2;
})(VatSuperType || {});
var VatTaxationMethod = /* @__PURE__ */ ((VatTaxationMethod2) => {
  VatTaxationMethod2["FLAT_RATE"] = "flat_rate";
  VatTaxationMethod2["EFFECTIVE"] = "effective";
  return VatTaxationMethod2;
})(VatTaxationMethod || {});
var tus_resumable = /* @__PURE__ */ ((tus_resumable2) => {
  tus_resumable2["1_0_0"] = "1.0.0";
  return tus_resumable2;
})(tus_resumable || {});
export {
  AccountFieldId,
  AccountKind,
  AccountObjectType,
  AccountType,
  AccountingBookingsFieldId,
  AccountingErrorType,
  AccountsSeedTemplate,
  AddressesFieldsFiltersId,
  AvatarType,
  BookingFieldId,
  BookingRelatedFieldId,
  BuiltinModuleTag,
  CategoryFieldId,
  CategoryKind,
  ComparisonOperator,
  ContactAddressCategory,
  ContactAddressFieldId,
  ContactRecordFieldId,
  CopyStatus,
  CustomSequenceErrorType,
  DateFormatsDash,
  DateFormatsDot,
  DateFormatsSlash,
  DateFormatsText,
  DatePrecision,
  DecimalSeparator,
  ErrorResource,
  FieldBlockType,
  FieldContentType,
  FieldGroupId,
  FieldId,
  FieldKind,
  FieldNumberType,
  FieldType,
  FieldValidatorKind,
  FileExplorerNodeKind,
  FileFolderFieldId,
  FileFolderType,
  FileRecordFieldId,
  FileVersionFieldId,
  FileimportProviderType,
  FileimportResourceRecordType,
  FilterPermissionType,
  FilterScope,
  FiltersetIndividualPermissionFieldId,
  HtmlTextEditorVariant,
  ImplicitRecordRelationFieldId,
  LayoutAlignVertical,
  LayoutRowType,
  LayoutSectionGroupErrorType,
  LayoutSectionGroupKind,
  LayoutSectionStatus,
  LayoutSectionType,
  LogicalOperator,
  MailboxAccountResourceRecordType,
  MailboxAccountResourceType,
  MailboxProviderType,
  NotesType,
  PriorityFieldId,
  PrivateCategoryFieldId,
  ProductPriceFieldId,
  ProductPriceRelatedFieldId,
  ProductPriceType,
  ProjectFieldId,
  PublicCategoryFieldId,
  RangeUnbound,
  RecordAccessRightType,
  RecordAccessRightsFieldId,
  RecordAction,
  RecordActionCreateFromMode,
  RecordEventAction,
  RecordEventFieldId,
  RecordEventTarget,
  RecordExplicitRelationFieldId,
  RecordFieldId,
  RecordIndividualPermissionFieldId,
  RecordPermissionType,
  RecordPriorityBucket,
  RecordPrioritySetStatus,
  RecordStatusBucket,
  RecordStatusSetErrorType,
  RecordStatusSetStatus,
  RecordStatusSlug,
  RecordTemplatesFolderId,
  RecordVersionEvent,
  ReferencesDisplayVariant,
  RelatedRecordFieldId,
  ResponsibleUserFieldId,
  RoleErrorType,
  RootFileFolderFieldId,
  Salutation,
  Services,
  SettingKind,
  SettingName,
  SettingType,
  SidebarStatus,
  SingleSelectionDisplayVariant,
  SpecialDataKind,
  StatusFieldId,
  SystemTemplateSlug,
  TableBarViewType,
  TableColumnKind,
  TagFieldId,
  TemplateFeatureType,
  TemplateFieldId,
  TenantConfigErrorType,
  TenantConfigState,
  TenantConfigStatus,
  TenantConfigType,
  TenantType,
  ThousandsSeparator,
  TimeFormats,
  TimePrecision,
  TimeZones,
  UserFieldId,
  VATType,
  VatCalculationBasis,
  VatSuperType,
  VatTaxationMethod,
  _type,
  accountObjectType,
  changeType,
  docType,
  errorCode,
  kind,
  lifecycleEvent,
  statusCode,
  tus_resumable
};
//# sourceMappingURL=types.gen.js.map